let SHOP = 'nbn-data-setup.myshopify.com';
let STOREFRONT_TOKEN = '70bc02637513e57dbfafb5526e3972f6';
  console.log('window.shop',window.shop)
if(window.shop == 'golftechuk.myshopify.com'){
   SHOP = 'ninebyninegolf.myshopify.com';
   STOREFRONT_TOKEN = 'b50c3ff4d3d2cbc7da628ad6c1fa6343';
}

const API_VERSION = '2025-10'; // change if needed
// Fetch only shaft products by product_type using Storefront API (paginated).
// Node/browser (fetch must be available). Replace SHOP and STOREFRONT_TOKEN.

const FLEX_GROUPS = {
  Ladies: [
    "ladies", "l", "regular 3", "sf305", "4.0", "3.5", "m0", "f1"
  ],
  Senior: [
    "senior", "a", "soft regular", "sf305x", "5.0", "f2", "regular 2", "m1"
  ],
  Regular: [
    "regular", "r", "regular 1", "sf405", "5.5", "f3", "regular +", "r300", "m2"
  ],
  Stiff: [
    "stiff", "s", "stiff regular", "sf505", "6.0", "f4", "s200", "stiff +", "m3"
  ],
  "X-Stiff": [
    "x stiff", "xstiff", "x", "sf505x", "6.5", "f5", "x100", "m4", "m5"
  ],
  "Tour X-Stiff": [
    "tour x stiff", "tx", "tx (tour x-stiff)", "7.0", "sf505xx"
  ]
};


async function shopifyGraphQL(query, variables = {}) {
  const url = `https://${SHOP}/api/${API_VERSION}/graphql.json`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });
  if (!res.ok) throw new Error(`HTTP ${res.status} - ${await res.text()}`);
  const payload = await res.json();
  if (payload.errors) throw new Error(JSON.stringify(payload.errors));
  return payload.data;
}

function slugify(input, options = {}) {
  if (!input) return '';

  const {
    separator = '-',
    lowercase = true,
    strict = true, // remove special chars aggressively
    trim = true
  } = options;

  let str = String(input);

  // Normalize accents (é → e, ö → o)
  str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  if (lowercase) {
    str = str.toLowerCase();
  }

  // Replace non-alphanumeric characters
  if (strict) {
    str = str.replace(/[^a-z0-9]+/g, separator);
  } else {
    str = str.replace(/[^\w]+/g, separator);
  }

  // Remove duplicate separators
  const sepRegex = new RegExp(`${separator}{2,}`, 'g');
  str = str.replace(sepRegex, separator);

  // Trim separators from start/end
  if (trim) {
    const trimRegex = new RegExp(`^${separator}|${separator}$`, 'g');
    str = str.replace(trimRegex, '');
  }

  return str;
}

async function fetchProductsByIds(ids = [], opts = {}) {
    const uniqueIds = [...new Set(
    ids
      .filter(Boolean)
      .map(id => {
        const value = String(id);

        // Already a Shopify GID
        if (value.startsWith('gid://')) {
          return value;
        }

        // Numeric Shopify product ID
        return `gid://shopify/Product/${value}`;
      })
  )];

  if (!uniqueIds.length) {
    return [];
  } 

  const query = /* GraphQL */ `
    query GetAdditionalShafts($ids: [ID!]!, $variantFirst: Int!, $country: CountryCode)
      @inContext(country: $country) {

      nodes(ids: $ids) {
        ... on Product {
          id
          handle
          title
          vendor
          productType
          availableForSale

          featuredImage {
            url
          }

          shortDescription: metafield(
            namespace: "custom",
            key: "short_description"
          ) {
            value
          }

          short_title: metafield(
            namespace: "custom",
            key: "short_title"
          ) {
            value
          }

          recommended: metafield(
            namespace: "custom",
            key: "is_recommended"
          ) {
            value
          }
          isAdditionalStockShaft: metafield(
              namespace: "custom",
              key: "is_additional_stock_shaft"
            ) {
              value
              id
            }

          zeroUpcharge: metafield(
            namespace: "custom",
            key: "is_zero_upcharge"
          ) {
            value
          }

          default_length: metafield(
            namespace: "custom",
            key: "default_length"
          ) {
            value
          }

          tip_size: metafield(
            namespace: "custom",
            key: "tip_size"
          ) {
            value
          }

          neck_fit: metafield(
            namespace: "custom",
            key: "neck_fit"
          ) {
            value
          }

          material: metafield(
            namespace: "custom",
            key: "material"
          ) {
            value
          }

          ball_flight: metafield(
            namespace: "custom",
            key: "ball_flight"
          ) {
            value
          }

          ball_spin: metafield(
            namespace: "custom",
            key: "ball_spin"
          ) {
            value
          }

          shaft_profile: metafield(
            namespace: "custom",
            key: "shaft_profile"
          ) {
            value
          }

          pre_selected_grip: metafield(
            namespace: "custom",
            key: "pre_selected_grip"
          ) {
            value
          }

          shaftThumb: metafield(
            namespace: "custom",
            key: "shaftThumb"
          ) {
            value
            id
            type

            reference {
              __typename

              ... on MediaImage {
                image {
                  url
                  altText
                  width
                  height
                }
              }
            }
          }

          gripthumb: metafield(
            namespace: "custom",
            key: "gripthumb"
          ) {
            value
            id
            type

            reference {
              __typename

              ... on MediaImage {
                image {
                  url
                  altText
                  width
                  height
                }
              }
            }
          }

          variants(first: $variantFirst) {
            edges {
              node {
                id
                title
                sku
                price {
                  amount
                  currencyCode
                }

                selectedOptions {
                  name
                  value
                }

                default_length: metafield(
                  namespace: "custom",
                  key: "default_length"
                ) {
                  value
                }

                iron_fit: metafield(
                  namespace: "custom",
                  key: "iron_fit"
                ) {
                  value
                }

                iron: metafield(
                  namespace: "custom",
                  key: "iron"
                ) {
                  value
                }
              }
            }
          }
        }
      }
    }
  `;

  const data = await shopifyGraphQL(query, {
    ids: uniqueIds,
    variantFirst: opts.variantFirst || 50,
    country: Shopify?.country || "GB"
  });

  return (data.nodes || [])
    .filter(Boolean)
    .map(p => {
      const variants = (p.variants?.edges || []).map(({ node: v }) => {
        const optionMap = {};

        (v.selectedOptions || []).forEach(opt => {
          optionMap[opt.name.toLowerCase()] = opt.value;
        });

        return {
          id: v.id,
          title: v.title,
          sku: v.sku,
          priceAmount: v.price ? Number(v.price.amount) : null,
          options: optionMap,
          flex: optionMap.flex || null,
          model: optionMap.model || null,
        };
      });

      return {
        id: p.id,
        handle: p.handle,
        title: p.title,
        productType: p.productType,
        vendor: p.vendor,
        featuredImage: p.featuredImage?.url || '',
        variants,
        availableForSale: p.availableForSale,

        recommended: p.recommended?.value || false,
        zeroUpcharge: p.zeroUpcharge?.value || false,

        default_length: p.default_length?.value || "",
        tip_size: p.tip_size?.value || "",
        neck_fit: p.neck_fit?.value || "",
        material: p.material?.value || "",
        ball_flight: p.ball_flight?.value || "",
        ball_spin: p.ball_spin?.value || "",
        shaft_profile: p.shaft_profile?.value || "",

        pre_selected_grip:
          p.pre_selected_grip?.value || false,

        shortDescription:
          renderShopifyRTE(p.shortDescription?.value) || "",

        short_title:
          p.short_title?.value || "",

        shaftThumb: p.shaftThumb,
        gripthumb: p.gripthumb,

        // Useful so UI/business logic knows why this shaft exists
        isAdditionalZeroUpcharge: true,
        isAdditionalStockShaft: normalizeBool(p.isAdditionalStockShaft?.value),
      };
    });
}

/**
 * Fetch shafts by product_type values.
 *
 * types: array of product_type strings e.g. ['Iron Shaft','Wood Shaft']
 * opts:
 *   pageSize: products per page (default 100, max around 250)
 *   variantFirst: how many variants to fetch per product page (default 50)
 *   variantSkus: optional array of SKUs to narrow returned variants (case-insensitive)
 *
 * Returns: [{ id, title, productType, variants: [{ id, title, sku, priceAmount, available }] }, ...]
 */
async function fetchShaftsByTypes(types = ['Iron Shaft','Wood Shaft'], opts = {}) {
  const pageSize = opts.pageSize || 100;
  const variantFirst = opts.variantFirst || 50;
  const variantSkus = (opts.variantSkus || []).map(s => (s||'').toString().toLowerCase());
  // build product_type query: product_type:'Iron Shaft' OR product_type:'Wood Shaft'
  const safeParts = types.map(t => `product_type:'${String(t).replace(/'/g,"\\'")}'`);
  const typeQuery = safeParts.join(' OR ');

  let after = null;
  const out = [];

  while (true) {
    const query = /* GraphQL */ `
      query GetShafts($first: Int!, $after: String, $query: String!, $variantFirst: Int!, $country: CountryCode) @inContext(country: $country) {
        products(first: $first, after: $after, query: $query) {
          edges {
            cursor
            node {
              id
              handle
              title
              vendor
              productType
              availableForSale
              featuredImage{
                url
              }
             shortDescription: metafield(namespace:"custom",key:"short_description"){
                value
                id
              }
             short_title: metafield(namespace:"custom",key:"short_title"){
                value
                id
              }
               recommended: metafield(namespace:"custom",key:"is_recommended"){
                value
                id
                }
                zeroUpcharge: metafield(namespace:"custom",key:"is_zero_upcharge"){
                value
                id
                }
                isAdditionalStockShaft: metafield(
                  namespace:"custom",
                  key:"is_additional_stock_shaft"
                ) {
                  value
                  id
                }
                default_length: metafield(namespace:"custom",key:"default_length"){
                  value          
                  id
                }
               tip_size: metafield(namespace:"custom",key:"tip_size"){
                  value          
                  id
                }
               neck: metafield(namespace:"custom",key:"neck"){
                  value          
                  id
                }
               tip_fit: metafield(namespace:"custom",key:"tip_fit"){
                  value          
                  id
                }
               neck_fit: metafield(namespace:"custom",key:"neck_fit"){
                  value          
                  id
                }
               material: metafield(namespace:"custom",key:"material"){
                  value          
                  id
                }
               pre_selected_grip: metafield(namespace:"custom",key:"pre_selected_grip"){
                  value          
                  id
                }
               pre_selected_shaft: metafield(namespace:"custom",key:"pre_selected_shaft"){
                  value          
                  id
                }
               ball_spin: metafield(namespace:"custom",key:"ball_spin"){
                  value          
                  id
                }
               ball_flight: metafield(namespace:"custom",key:"ball_flight"){
                  value          
                  id
                }
               shaft_profile: metafield(namespace:"custom",key:"shaft_profile"){
                  value          
                  id
                }
               shaftThumb: metafield(namespace: "custom", key: "shaftThumb") {
                  value
                  id
                  type
                  reference {
                    __typename
                    ... on MediaImage {
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                }
                gripthumb: metafield(namespace: "custom", key: "gripthumb") {
                  value
                  id
                  type
                  reference {
                    __typename
                    ... on MediaImage {
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                }
              variants(first: $variantFirst) {
                pageInfo { hasNextPage }
                edges {
                  node {
                    id
                    title
                    sku
                    price { amount currencyCode }
                    selectedOptions{
                      name
                      value
                    }
                    default_length: metafield(namespace:"custom",key:"default_length"){
                      value          
                      id
                    }
                    iron_fit: metafield(namespace:"custom",key:"iron_fit"){
                      value          
                      id
                    }
                    iron: metafield(namespace:"custom",key:"iron"){
                      value          
                      id
                    }
                  }
                }
              }
            }
          }
          pageInfo { hasNextPage }
        }
      }
    `;
    const variables = { first: pageSize, after, query: typeQuery, variantFirst, country: Shopify?.country || "GB" };
    const data = await shopifyGraphQL(query, variables);
    const edges = (data.products && data.products.edges) || [];
    // console.log('alledges',edges)

    for (const edge of edges) {
      const p = edge.node;
      // Additional stock shafts must never enter through
      // the normal product_type query.
      // They are added explicitly later when allowed.
      if (normalizeBool(p.isAdditionalStockShaft?.value)) {
        continue;
      }

      // flatten first page of variants
      let variants = (p.variants.edges || []).map(e => {
        const v = e.node;

        // Convert selectedOptions array → object
        const optionMap = {};
        (v.selectedOptions || []).forEach(opt => {
          optionMap[opt.name.toLowerCase()] = opt.value;
        });

        return {
          id: v.id,
          title: v.title,
          sku: v.sku,
          priceAmount: v.price ? Number(v.price.amount) : null,

          // raw options
          options: optionMap,

          // normalized fields (what your UI actually needs)
          flex: optionMap.flex || null,
          model: optionMap.model || null,
        };
      });


      // if variantSkus provided but not all SKUs present on first page, you can page remaining variants.
      // For performance we only fetch remaining variants if variantSkus is provided AND some requested SKUs are missing.
      const skusRequested = variantSkus.length > 0;
      if (skusRequested) {
        const presentSkus = new Set(variants.map(v => (v.sku||'').toLowerCase()));
        const missing = variantSkus.filter(sku => !presentSkus.has(sku));
        if (missing.length && p.variants.pageInfo && p.variants.pageInfo.hasNextPage) {
          // fetch all variants for this product (page through) to find requested SKUs
          const more = await fetchAllVariantsForProduct(p.id);
          // append unique variants
          const existingIds = new Set(variants.map(v => v.id));
          for (const mv of more) {
            if (!existingIds.has(mv.id)) {
              variants.push(mv);
            }
          }
        }
        // filter to only requested SKUs (case-insensitive)
        variants = variants.filter(v => variantSkus.includes((v.sku||'').toLowerCase()));
      }

      // console.log('p.shaftThumb:: ',p)
      // console.log('p.gripthumb:: ',p.gripthumb)
      // if variantSkus not provided, we keep whatever variants were fetched (first page)
      out.push({
        id: p.id,
        handle: p.handle,
        title: p.title,
        productType: p.productType,
        vendor: p.vendor,
        featuredImage: p.featuredImage?.url || '',
        variants:variants,
        availableForSale:p.availableForSale,
        recommended:p.recommended?.value || false,
        zeroUpcharge:p.zeroUpcharge?.value || false,
        default_length:p.default_length?.value || "",
        tip_size:p.tip_size?.value || "",
        neck_fit:p.neck_fit?.value || "",
        material:p.material?.value || "",
        ball_flight:p.ball_flight?.value || "",
        ball_spin:p.ball_spin?.value || "",
        shaft_profile:p.shaft_profile?.value || "",
        pre_selected_grip:p.pre_selected_grip?.value || false,
        shortDescription:renderShopifyRTE(p.shortDescription?.value) || "",
        short_title:(p.short_title?.value) || "",
        shaftThumb:p.shaftThumb,
        gripthumb:p.gripthumb,
        isAdditionalStockShaft: normalizeBool(p.isAdditionalStockShaft?.value),

      });
    }

    if (!data.products.pageInfo.hasNextPage) break;
    after = edges.length ? edges[edges.length - 1].cursor : null;
    if (!after) break;
  }

  // Add brand-specific shafts when they ARE allowed.
  if (opts.additionalShaftIds?.length) {
    const additionalShafts = await fetchProductsByIds(
      opts.additionalShaftIds,
      {
        variantFirst
      }
    );

    const existingIds = new Set(out.map(p => p.id));

    for (const shaft of additionalShafts) {

      // Safety check:
      // only products explicitly marked as additional stock shafts
      // can enter through this path.
      if (!shaft.isAdditionalStockShaft) {
        continue;
      }

      if (!existingIds.has(shaft.id)) {
        out.push({
          ...shaft,
          isAdditionalZeroUpcharge: true
        });
      }
    }
  }

  return out;
}

/**
 * Helper: fetch all variants for a product (cursor-based). Returns same variant shape used above.
 * Use only when necessary (keeps normal calls fast).
 */
async function fetchAllVariantsForProduct(productGid) {
  const perPage = 50;
  let after = null;
  const all = [];
  while (true) {
    const query = /* GraphQL */ `
      query ProductVariants($id: ID!, $first: Int!, $after: String, $country: CountryCode) @inContext(country: $country) {
        node(id: $id) {
          ... on Product {
            variants(first: $first, after: $after) {
              pageInfo { hasNextPage }
              edges {
                node { id title sku price { amount currencyCode } }
                cursor
              }
            }
          }
        }
      }
    `;
    // Map the currency to a Country Code if Shopify.country isn't available
    const countryMapping = { 'USD': 'US', 'GBP': 'GB', 'EUR': 'FR', 'SEK': 'SE', 'CAD': 'CA' };
    const activeCountry = Shopify?.country || countryMapping[Shopify.currency.active] || 'GB';
    const data = await shopifyGraphQL(query, { id: productGid, first: perPage, after, country: activeCountry });
    const edges = (data.node && data.node.variants && data.node.variants.edges) || [];
    for (const e of edges) {
      const v = e.node;
      all.push({
        id: v.id,
        title: v.title,
        sku: v.sku,
        priceAmount: v.price ? v.price.amount : null
      });
    }
    if (!(data.node && data.node.variants && data.node.variants.pageInfo && data.node.variants.pageInfo.hasNextPage)) break;
    after = edges.length ? edges[edges.length - 1].cursor : null;
    if (!after) break;
  }
  return all;
}


// Get the current club config from your JSON
const currentClubConfig = CONFIG.clubs_head_type[currentProduct?.type]; // e.g., "Driver"

// Helper to calculate final price
const getFinalPrice = (basePrice, discountPercent) => {
    const discountAmount = (basePrice * (discountPercent || 0)) / 100;
    const finalPrice = basePrice - discountAmount;
    return Math.max(0, finalPrice); // Ensure price never goes below 0
};


function showSectionLoader(sectionId) {
  document
    .querySelector(`#${sectionId} .config-loader`)
    ?.classList.remove('hidden');

  if (sectionId === 'shaft-step') {
    document
      .querySelectorAll('#open-shaft-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'none';
        btn.disabled = true;
      });
  }

  if (sectionId === 'grip-step') {
    document
      .querySelectorAll('#open-grip-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'none';
        btn.disabled = true;
      });
  }
}


function hideSectionLoader(sectionId) {
  // Hide loader for this section
  document
    .querySelector(`#${sectionId} .config-loader`)
    ?.classList.add('hidden');

  // Show only the relevant button
  if (sectionId === 'shaft-step') {
    document
      .querySelectorAll('#open-shaft-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'block';
        btn.disabled = false;
      });
  }

  if (sectionId === 'grip-step') {
    document
      .querySelectorAll('#open-grip-drawer-btn')
      .forEach(btn => {
        btn.style.display = 'block';
        btn.disabled = false;
      });
  }
}



function getShopifyImageUrl(src, { width, height, crop } = {}) {
  if (!src || typeof src !== 'string') return src;

  // Ignore non-Shopify CDN images
  if (!src.includes('cdn.shopify.com')) return src;

  // Split query params
  const [url, query] = src.split('?');

  // Extract extension
  const match = url.match(/\.(jpg|jpeg|png|webp)$/i);
  if (!match) return src;

  const ext = match[0];
  const base = url.replace(ext, '');

  // Build size suffix
  let size = '';
  if (width && height) size = `_${width}x${height}`;
  else if (width) size = `_${width}x`;

  // Rebuild URL
  let finalUrl = `${base}${size}${ext}`;
  if (query) finalUrl += `?${query}`;

  // Optional crop (center, top, etc.)
  if (crop) {
    finalUrl += (query ? '&' : '?') + `crop=${crop}`;
  }

  return finalUrl;
}


function normalizeBool(val) {
  return val === true || val === 'true' || val === 1 || val === '1';
}


function getBrandConfigForCurrentHead() {
  const vendor = (window.currentProduct?.vendor || "").toLowerCase();
  if (!vendor) return null;

  return META_BRANDS.find(
    b => (b.title || "").toLowerCase() === vendor
  ) || null;
}


function getNumericProductId(gid) {
  if (!gid) return null;

  const match = String(gid).match(/Product\/(\d+)/);
  return match ? Number(match[1]) : null;
}

function renderShopifyRTE(rte) {
  if (!rte) return "";

  let data;
  try {
    data = typeof rte === "string" ? JSON.parse(rte) : rte;
  } catch (e) {
    return "";
  }

  if (!data || !Array.isArray(data.children)) return "";

  return data.children.map(renderRTENode).join("");
}

function renderRTENode(node) {
  if (!node) return "";

  switch (node.type) {
    case "paragraph":
      return `<p>${(node.children || []).map(renderRTENode).join("")}</p>`;

    case "text": {
      let text = escapeHtml(node.value || "");

      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;

      return text.replace(/\n/g, "<br>");
    }

    case "heading": {
      const level = node.level || 3;
      return `<h${level}>${(node.children || [])
        .map(renderRTENode)
        .join("")}</h${level}>`;
    }

    case "list":
      const tag = node.listType === "ordered" ? "ol" : "ul";
      return `<${tag}>${(node.children || [])
        .map(renderRTENode)
        .join("")}</${tag}>`;

    case "list-item":
      return `<li>${(node.children || [])
        .map(renderRTENode)
        .join("")}</li>`;

    default:
      return "";
  }
}

function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function buildInfoAccordion(rteDescription) {
  const html = rteDescription;
  if (!html) return "";

  return `
    <div class="nbn-info-accordion">
      <button class="nbn-info-toggle" type="button">
        INFO +
      </button>
      <div class="nbn-info-content">
        ${html}
      </div>
    </div>
  `;
}



function extractProductIdFromMetafield(value) {
  if (!value) return null;

  // CASE 1: Shopify already gives numeric product ID (YOUR CASE)
  if (typeof value.id === 'number') {
    return value.id;
  }

  // CASE 2: id is a GID string
  if (typeof value.id === 'string') {
    return getNumericProductId(value.id);
  }

  // CASE 3: whole value is a GID string
  if (typeof value === 'string') {
    return getNumericProductId(value);
  }

  return null;
}


function getProductImage(product) {
  return (
    product?.shaftThumb?.reference?.image?.url || ""
  );
}

function getProductImageGrip(product) {
  return (
    product?.gripthumb?.reference?.image?.url || ""
  );
}

//not needed
// function renderVariantRadios({ variants, selectedVariant, onChange, containerId }) {
//   console.log('variants',variants)
//   const container = document.getElementById(containerId);
//   if (!container) return;

//   container.innerHTML = "";

//   const optionKeys = Object.keys(variants[0]?.options || {});
//   if (!optionKeys.length) return;

//   let current = selectedVariant || variants.find(v => v.available) || variants[0];

//   optionKeys.forEach(key => {
//     const values = [...new Set(variants.map(v => v.options[key]).filter(Boolean))];

//     container.insertAdjacentHTML("beforeend", `
//       <div class="variant-group">
//         <label>${key.replace(/_/g," ").replace(/\b\w/g,c=>c.toUpperCase())}</label>
//         <div class="variant-radios" data-key="${key}"></div>
//       </div>
//     `);

//     const wrap = container.querySelector(`[data-key="${key}"]`);

//     values.forEach(val => {
//       const match = variants.find(v => v.options[key] === val && v.available);
//       const disabled = !match;

//       const checked = current.options[key] === val || (!current && !disabled);

//       wrap.insertAdjacentHTML("beforeend", `
//         <label class="iron-flex-option radio-option ${disabled ? "disabled" : ""}">
//           <input type="radio" name="${containerId}-${key}" value="${val}"
//             ${checked ? "checked" : ""} ${disabled ? "disabled" : ""}>
//           <span>${val}</span>
//         </label>
//       `);
//     });
//   });

//   bindVariantRadioEvents({ variants, containerId, onChange });
// }

function bindVariantRadioEvents({ variants, containerId, onChange }) {
  const container = document.getElementById(containerId);

  container.querySelectorAll("input[type=radio]").forEach(radio => {
    radio.addEventListener("change", () => {
      const selections = {};
      container.querySelectorAll("input:checked").forEach(r => {
        const key = r.name.replace(containerId + "-", "");
        selections[key] = r.value;
      });

      const next = variants.find(v =>
        Object.entries(selections).every(([k, val]) => v.options[k] === val)
      );

      if (next) onChange(next);
    });
  });
}


function getPreSelectedShaftNumericId() {
  const mf = window.currentProduct?.metafields?.pre_selected_shaft;
  const resolved = extractProductIdFromMetafield(mf);

  // console.log('[DEBUG] pre_selected_shaft raw:', mf);
  // console.log('[DEBUG] resolved numeric ID:', resolved);

  return resolved;
}

function getAdapterOptions() {
  const brand = getBrandConfigForCurrentHead();
  
  // 1. Check for Product Metafields (from your screenshot)
  const metaSettings = currentProduct?.metafields?.adapter_settings;
  const metaDefault  = currentProduct?.metafields?.default_adapter_settings;

  // 2. Determine the options source
  // Use metafield array if it exists and has items, otherwise fallback to brand config
  const finalOptions = (Array.isArray(metaSettings) && metaSettings.length > 0) 
    ? metaSettings 
    : (brand?.adapter_settings || null);

  if (!finalOptions) return null;

  // 3. Determine the default value
  // Priority: Metafield Default > Brand Default > First item in the list
  let finalDefault = metaDefault || brand?.default_adapter || finalOptions[0];

  // Safety check: ensure the default actually exists in the options list
  if (!finalOptions.includes(finalDefault)) {
    finalDefault = finalOptions[0];
  }

  return {
    options: finalOptions,
    default: finalDefault
  };
}

function renderAdapterDropdown(container) {
  const cfg = getAdapterOptions();
  // console.log('cfg',cfg)
  if (!cfg || cfg.options.length == 0 || currentProduct?.type?.toLowerCase() =="wedge" || currentProduct?.type?.toLowerCase() =="driving iron") return;

  const optionsHtml = cfg.options
    .map(opt => `
      <option value="${opt}" ${opt === cfg.default ? "selected" : ""}>
        ${opt}
      </option>
    `)
    .join("");

  const html = `
  <div class="nbn-advanced">  
  <div class="nbn-shaft-adapter nbn-custom-select">
      <label>Adaptor</label>
      <select id="shaft-adapter-select">
        ${optionsHtml}
      </select>
    </div>
  </div>
  `;

  container.insertAdjacentHTML("beforeend", html);

  // Persist selection
  container
    .querySelector("#shaft-adapter-select")
    ?.addEventListener("change", e => {
      window.__selectedAdapter = e.target.value;
    });

  // default
  window.__selectedAdapter = cfg.default;
}

function buildSpineTooltip() {
  return `
    <div class="nbn-tooltip">
      <p>
        Aligning the shaft’s natural spine to ensure consistent performance and reduce unwanted flex
      </p>
    </div>
  `;
}


function renderSpineAlignment(container) {
  const html = `
  <div class="nbn-advanced">
    <div class="nbn-shaft-spine">
      <label class="nbn-checkbox">
      <span>Spine Alignment (+${theme.currencySymbol}10)</span>
        <input type="checkbox" id="spine-alignment-checkbox" value="${window.spine_alignment.variants[0].id}" data-pric="${window.spine_alignment.variants[0].price}">
      </label>

      <button
        class="nbn-info-btn"
        type="button"
        aria-label="Spine Alignment info"
      >
        i
        ${buildSpineTooltip()}
      </button>
    </div>
  </div>
  `;

  container.insertAdjacentHTML("beforeend", html);

  container
    .querySelector("#spine-alignment-checkbox")
    ?.addEventListener("change", e => {
      window.__spineAlignment = e.target.checked;
       updateBuildPrice(); // 👈 ADD
    });

  window.__spineAlignment = false;
}

function initPreSelectedShaft(groupedProducts) {
  const preSelectedProductId = getPreSelectedShaftNumericId();
  if (!preSelectedProductId) return;

  const product = groupedProducts.find(
    p => getNumericProductId(p.productId) === preSelectedProductId
  );

  if (!product || !product.variants.length) return;

  // pick first available variant
  const variant =
    product.variants.find(v => v.available) || product.variants[0];
    const { label, value } = buildVariantOptionSummary(variant.options);
    const summary = buildShaftOptionSummary(variant);

    // console.log('variant',variant)
  window.__selectedShaft = {
    productId: product.productId,
    productTitle: product.productTitle,
    variantId: variant.variantId,
    flex: variant.flex,
    model: variant.model,
    price: Number(variant.price||0),
    featuredImage: product.featuredImage,
    ...summary,
    product:product,
    variant:variant,
    productType:product.productType
  };
  window.__currentShaftProduct = window.__selectedShaft;

  // update summary UI immediately
  updateBuildPrice(); // 👈 ADD THIS

}


function buildInitialShaftOrder(groupedProducts) {
  const preSelectedId = Number(getPreSelectedShaftNumericId());

  const buckets = {
    preSelected: [],
    recommended: [],
    zeroUpcharge: [],
    others: []
  };

  groupedProducts.forEach(p => {
    const pid = getNumericProductId(p.productId);

    // 1. Absolute Priority: Pre-Selected
    if (preSelectedId && pid === preSelectedId) {
      buckets.preSelected.push(p);
      return; // Stop here for this product
    }

    // 2. Second Priority: Zero Upcharge
    // Moving this above 'recommended' ensures free shafts are grouped together
    if (normalizeBool(p.zeroUpcharge)) {
      buckets.zeroUpcharge.push(p);
      return; // Stop here
    }

    // 3. Third Priority: Recommended
    // Only products that ARE recommended but NOT free end up here
    if (normalizeBool(p.recommended)) {
      buckets.recommended.push(p);
      return; // Stop here
    }

    // 4. Final Fallback: Others
    buckets.others.push(p);
  });

  return buckets;
}

function getLengthConfigForCurrentHead() {
  const headType = window.currentProduct?.type;
  if (!headType) return null;

  const headCfg = CONFIG?.clubs_head_type?.[headType];
  if (!headCfg || !headCfg.length_to_pull) return null;

  return window.META_LENGTHS.find(
    l => l.for_type === headCfg.length_to_pull
  ) || null;
}

function normalizeFlexValue(raw) {
  if (!raw) return '';

  return raw
    .toString()
    .toLowerCase()
    .replace(/\//g, ' ')
    .replace(/\+/g, ' plus')
    .replace(/\s+/g, ' ')
    .trim();
}

function resolveFlexGroup(variantFlexText) {
  const norm = normalizeFlexValue(variantFlexText);

  for (const [group, aliases] of Object.entries(FLEX_GROUPS)) {
    if (aliases.some(a => norm.includes(a))) {
      return group;
    }
  }

  return null; // unknown / uncategorized
}



function formatKey(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}


function renderVariantRadios({ variants, selectedVariant, onChange, containerId }) {
  const container = document.getElementById(containerId);
  if (!container || !variants.length) return;

  container.innerHTML = "";

   // 1. Wedge: lock shaft "Iron" option to PW / 9i / PW and hide it
  let effectiveVariants = variants;
  const typeLower = (window.currentProduct?.type || "").toLowerCase();
  const tags = window.currentProduct?.tags || [];
  const isWedge =
    containerId === "shaft-variant-options" &&
    (typeLower.includes("wedge") || tags.includes("wedge"));

    // Detect Iron option key ("iron" / "irons")
  const ironKey = Object.keys(variants[0]?.options || {})
                        .find(k => /^irons?$/i.test(k.trim()));

  // Iron is hidden only when it was actually locked; otherwise the customer
  // must see it, or the first variant (2i) gets picked silently.
  let ironLocked = false;

  if (isWedge && ironKey) {
    const ironVal = v => String(v.options?.[ironKey] || "");
    // Prefer a PW value ("PW", "9i/PW"), then plain "9i" (e.g. KBS PGI: SKU 9i/PW, option 9i)
    let wedgeVariants = variants.filter(v => /\bpw\b/i.test(ironVal(v)));
    if (!wedgeVariants.length) {
      wedgeVariants = variants.filter(v => /\b9i\b/i.test(ironVal(v)));
    }
    if (wedgeVariants.length) {
      effectiveVariants = wedgeVariants;
      ironLocked = true;
    }
  }

  // 2. Option keys (Iron hidden for wedges once locked)
  const optionKeys = Object.keys(effectiveVariants[0].options || {})
                          .filter(key => !(ironLocked && key === ironKey));

  // 3. Determine currently selected variant
  let current = selectedVariant && effectiveVariants.find(v => v.variantId === selectedVariant.variantId)
                ? selectedVariant
                : effectiveVariants.find(v => v.available) || effectiveVariants[0];

  // Sync stored selection if it was outside the allowed set (e.g. defaulted to 2i)
  if (ironLocked && (!selectedVariant || selectedVariant.variantId !== current.variantId)) {
    onChange(current);
  }

  // 4. Iterate through keys to build dependent UI
  let filteredPool = effectiveVariants;

  optionKeys.forEach((key, index) => {
    // For the CURRENT key, we show values available in the filtered pool 
    // (the pool was filtered by the PREVIOUS selection)
    const availableValues = [...new Set(filteredPool.map(v => v.options[key]))].filter(Boolean);

    // If we want to show ALL values but disable ones that don't match, 
    // we use the master 'effectiveVariants' list for the UI:
    const allPossibleValuesForKey = [...new Set(effectiveVariants.map(v => v.options[key]))].filter(Boolean);

    container.insertAdjacentHTML("beforeend", `
      <div class="variant-group" data-option="${key}">
        <label>${key.replace(/_/g, " ")}</label>
        <div class="variant-radios" data-key="${key}"></div>
      </div>
    `);

    const wrap = container.querySelector(`[data-key="${key}"]`);

    allPossibleValuesForKey.forEach(val => {
      // Logic: Is this value valid given what was selected in the options ABOVE it?
      const isPossible = availableValues.includes(val);
      const isChecked = current.options[key] === val;

      wrap.insertAdjacentHTML("beforeend", `
        <label class="radio-option ${isPossible ? "" : "hidden-option disabled"}">
          <input type="radio"
                 name="${containerId}-${key}"
                 value="${val}"
                 ${isChecked ? "checked" : ""}
                 ${isPossible ? "" : "disabled"}>
          <span>${val}</span>
        </label>
      `);
    });

    // 5. CRITICAL: Narrow the pool for the NEXT option based on current selection
    const currentSelectionForKey = current.options[key];
    filteredPool = filteredPool.filter(v => v.options[key] === currentSelectionForKey);
  });

  // 6. Bind events to trigger re-render
  bindVariantRadioEvents({
    variants: effectiveVariants,
    containerId,
    onChange
  });
}

function bindVariantRadioEvents({ variants, containerId, onChange }) {
  const container = document.getElementById(containerId);

  container.querySelectorAll("input[type=radio]").forEach(radio => {
    radio.addEventListener("change", () => {
      const selections = {};
      container.querySelectorAll("input:checked").forEach(r => {
        const key = r.name.replace(containerId + "-", "");
        selections[key] = r.value;
      });

      // Find the best matching variant
      // 1. Try to find exact match
      let next = variants.find(v => 
        Object.entries(selections).every(([k, val]) => v.options[k] === val)
      );

      // 2. If no exact match (because options changed), find first available with current first selection
      if (!next) {
        const firstKey = Object.keys(selections)[0];
        next = variants.find(v => v.options[firstKey] === selections[firstKey] && v.available) || 
               variants.find(v => v.options[firstKey] === selections[firstKey]);
      }

      if (next) {
        onChange(next);
        renderVariantRadios({
          variants,
          selectedVariant: next,
          containerId,
          onChange
        });
      }
    });
  });
}


function getCurrentSelections(containerId) {
  const selections = {};
  const container = document.getElementById(containerId);

  container.querySelectorAll("input:checked").forEach(r => {
    const key = r.name.replace(containerId + "-", "");
    selections[key] = r.value;
  });

  return selections;
}

function refreshVariantAvailability({ variants, containerId, selectedVariant }) {
  const container = document.getElementById(containerId);
  const currentSelections = getCurrentSelections(containerId);

  container.querySelectorAll(".variant-radios").forEach(group => {
    const key = group.dataset.key;

    group.querySelectorAll("input").forEach(input => {
      const value = input.value;

      const testSelection = { ...currentSelections, [key]: value };

      const match = variants.some(v =>
        Object.entries(testSelection).every(([k, val]) => v.options[k] === val) &&
        v.available
      );

      input.disabled = !match;

      if (!match) {
        input.checked = false;
        input.closest("label")?.classList.add("disabled");
      } else {
        input.closest("label")?.classList.remove("disabled");
      }

      if (selectedVariant && selectedVariant.options[key] === value && match) {
        input.checked = true;
      }
    });
  });
}


function buildShaftOptionSummary(variant) {
  if (!variant || !variant.options) {
    return { optionLabel: "", optionValue: "" };
  }

  const entries = Object.entries(variant.options);

  return {
    optionLabel: entries.map(([k]) =>
      k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    ).join(" / "),
    optionValue: entries.map(([, v]) => v).join(" / ")
  };
}

function drawerClose(id) {
  const drawer = document.getElementById(id);
  if (!drawer) return;
  drawer.classList.remove("active");
}


function getPreSelectedGripNumericId() {
  return extractProductIdFromMetafield(
    window.currentProduct?.metafields?.pre_selected_grip
  );
}

/************** 
 * Grips Helper Starts
 * **************
 */


function updateGripPriceUI() {
  const el = document.querySelector('.nbn-grip-price');
  // 1. Safety checks: element exists, grip is selected, and config is available
  if (!el || !window.__selectedGrip || !currentClubConfig) return;

  // 2. Calculate the price
  const minBasePrice = Math.min(...window.__selectedGrip.product.variants.map(v => v.price));
  
  // Use GRIP discount here, not shaft
  const discount = currentClubConfig.grip_discount_amount || 0;
  
  // Assuming getFinalPrice is defined globally as discussed:
  const finalPrice = getFinalPrice(minBasePrice, discount);

  // 3. Render the HTML
  const isZeroUpcharge = normalizeBool(window.__selectedGrip.product.zeroUpcharge) || finalPrice <= 0;

  el.innerHTML = getPriceDisplayHTML(minBasePrice,discount,window.__selectedGrip.product.zeroUpcharge,'grip')
}

function initPreSelectedGrip(grips) {
  const preId = getPreSelectedGripNumericId();
  if (!preId) return;

  const grip = grips.find(g => getNumericProductId(g.productId) === preId);
  if (!grip || !grip.variants.length) return;

  // console.log('selected grip product',grip)
  
  const v = grip.variants[0];
  const { label, value } = buildVariantOptionSummary(v.options);
  const summary = buildShaftOptionSummary(v);
  window.__selectedGrip = {
    productId: grip.productId,
    productTitle: grip.productTitle,
    variantId: v.variantId,
    price: Number(v.price||0) ,
    featuredImage: grip.featuredImage,
    brand: grip.vendor,
    ...summary,
    product:grip,
    variant:v,
  };

  // console.log('window.__selectedGrip',window.__selectedGrip)

  updateSelectedGripLabel(window.__selectedGrip);
  renderSelectedGripSummary(window.__selectedGrip);

  updateBuildPrice();
  updateGripPriceUI();

  // console.log('window.__selectedGrip 766',window.__selectedGrip)
  if (window.__selectedGrip) {
    renderGripVariantRadios(window.__selectedGrip.product);
  }
  if(document.getElementById("open-grip-drawer")){
      document.getElementById("open-grip-drawer").style.display ='block';
  }
}

async function initGripFlow() {
  const headType = currentProduct.type;
  const cfg = CONFIG?.clubs_head_type?.[headType];
  
  if (!cfg?.grips_to_pull) return;

  let grips = await fetchShaftsByTypes(
    cfg.grips_to_pull.map(normalizeProductTypeLabel),
    { pageSize: 50, variantFirst: 50 }
  );

  // 1. Group by product
  const groupedGrips = groupGripsByProduct(flattenGrips(grips));
  // console.log('groupedGrips',groupedGrips)

  // 2. Sort into buckets
  const buckets = {
    recommended: [],
    zeroUpcharge: [],
    others: []
  };

  groupedGrips.forEach(grip => {
    const preId = getPreSelectedGripNumericId();
    const isPreSelected = getNumericProductId(grip.productId) === preId;
    
    if (isPreSelected) {
      buckets.recommended.push(grip);
    } else if (normalizeBool(grip.zeroUpcharge)) {
      buckets.zeroUpcharge.push(grip);
    } else {
      buckets.others.push(grip);
    }
  });

  // 3. SET THE STATE
  // initPreSelectedGrip usually handles what shows on the main product page initially
  initPreSelectedGrip(groupedGrips);

  // 4. INITIALIZE THE DRAWER
  // We pass 'buckets' here. The drawer init function will handle the rendering 
  // of results inside the drawer so we don't have to call it twice.
  initGripDrawer(buckets);
  
  // console.log('Grip Flow Initialized with Buckets:', buckets);
}

function renderGroupedGripBuckets(buckets) {
  const container = document.getElementById('grip-results');
  if (!container) return;
  container.innerHTML = '';

  // 1. Render Recommended (Will hide automatically if empty)
  renderGripSection('Recommended for You', buckets.recommended);

  // 2. Render Zero Upcharge (Will hide automatically if empty)
  renderGripSection('Zero Upcharge Grips', buckets.zeroUpcharge);

  // 🔥 FIX 2: Determine if "All Grips" should be collapsed
  // We only collapse "All Grips" if there is at least one item in the priority sections above it.
  const hasPriorityItems = (buckets.recommended?.length > 0) || (buckets.zeroUpcharge?.length > 0);
  const shouldCollapseOthers = hasPriorityItems;

  // 3. Render All Others
  renderGripSection('All Grips', buckets.others, shouldCollapseOthers);
}

function renderGripSection(title, products, collapsible = false) {
  // 🔥 FIX 1: If there are no products, exit immediately to hide the header
  if (!products || products.length === 0) return;

  const container = document.getElementById('grip-results');
  const section = document.createElement('div');
  section.className = 'shaft-section grip-section'; 

  section.innerHTML = `
    <h3 class="shaft-section-title">${title}</h3>
    <div class="shaft-section-list"></div>
  `;

  const list = section.querySelector('.shaft-section-list');
  products.forEach(p => renderGripProduct(p, list));

  // Only collapse if requested AND we actually have content to hide
  if (collapsible) {
    section.classList.add('is-collapsed');
  }

  container.appendChild(section);
}

function flattenGrips(products) {
  // console.log('grup products:: ',products)
  const out = [];
  products.forEach(p => {
    (p.variants || []).forEach(v => {
      out.push({
        productId: p.id,
        productTitle: p.title,
        variantTitle: v.title,
        featuredImage: getShopifyImageUrl(p.featuredImage, { width: 280 }),
        variantId: v.id,
        vendor: p.vendor,
        available: p.availableForSale,
        price: Number(v.priceAmount||0),                
        shortDescription: p.shortDescription || '',
        short_title: p.short_title || '',
        recommended: p.recommended || false,
        zeroUpcharge: p.zeroUpcharge || false,
        options:v.options,
        gripthumb:p.gripthumb,
        shaftThumb:p.shaftThumb,
      });
    });
  });
  return out;
}

function groupGripsByProduct(items) {
  const map = new Map();

  items.forEach(i => {
    // console.log('grip map ',i)
    if (!map.has(i.productId)) {
      map.set(i.productId, {
        productId: i.productId,
        productTitle: i.productTitle,
        variantTitle: i.variantTitle,
        featuredImage: i.featuredImage,
        variantId: i.variantId,
        vendor: i.vendor,
        available: i.availableForSale,
        price: Number(i.priceAmount||0),                
        shortDescription: i.shortDescription || '',
        short_title: i.short_title || '',
        recommended: i.recommended || false,
        zeroUpcharge: i.zeroUpcharge || false,
        options:i.options,
        gripthumb:i.gripthumb,
        shaftThumb:i.shaftThumb,
        variants: []
      });
    }
    map.get(i.productId).variants.push({
      variantId: i.variantId,
      price: i.price,
      color: i.color,
      size: i.size,
      price: Number(i.price || 0),
      available: i.available,
      options:i.options,
      variantTitle:i.variantTitle
    });
  });

  return [...map.values()];
}

function bindShowAllGripsButton() {
  const btn = document.getElementById('show-all-grips-btn');
  if (!btn) return;

  // Remove existing listeners to prevent duplicates if init is called multiple times
  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);

  newBtn.addEventListener('click', () => {
    expandAllGripSections();
    // After expanding, we check if we need to hide the button
    updateShowAllGripsButton();
  });

  // Initial check to see if button should be visible
  updateShowAllGripsButton();
}

function expandAllGripSections() {
  // Target only grip sections specifically
  document
    .querySelectorAll('#grip-results .shaft-section.is-collapsed') 
    .forEach(section => section.classList.remove('is-collapsed'));
}

function updateShowAllGripsButton() {
  const btn = document.getElementById('show-all-grips-btn');
  if (!btn) return;

  // Logic: Show button ONLY if filters are NOT active AND there are hidden sections
  const show = !hasActiveGripFilters() && hasCollapsedGripSections();
  
  btn.style.display = show ? 'block' : 'none';
}

function hasCollapsedGripSections() {
  // Returns true if any section in the grip results is currently collapsed
  return document.querySelectorAll('#grip-results .shaft-section.is-collapsed').length > 0;
}

function hasActiveGripFilters() {
  // Check your specific ID for the grip brand filter dropdown
  const brandFilter = document.getElementById('grip-brand-select'); // or 'grip-brand-filter'
  
  // If filter exists and value is not "All", return true
  return brandFilter && brandFilter.value !== 'all' && brandFilter.value !== '';
}


function populateGripBrandFilter(grips) {
  const sel = document.getElementById("filter-grip-brand");
  if (!sel) return;

  // Reset with "All" option
  sel.innerHTML = `<option value="__all__" selected>All brands</option>`;

  const brands = [...new Set(grips.map(g => g.vendor).filter(v => v && v.trim()))].sort();

  brands.forEach(b => {
    const o = document.createElement("option");
    o.value = b;
    o.textContent = b;
    sel.appendChild(o);
  });
}


function bindGripFilters() {
  const vendorSelect = document.getElementById("filter-grip-brand");
  const searchInput = document.getElementById("grip-search");
  
  if (!vendorSelect || !searchInput) return;

  const handleFilter = () => {
    const selectedVendor = vendorSelect.value;
    const searchText = searchInput.value.toLowerCase().trim();

    // Check if any filter is actually active (assuming empty string or "__all__" is default)
    const isFilterActive = (selectedVendor !== "__all__" && selectedVendor !== "") || searchText !== "";

    // --- SCENARIO 1: NO FILTERS ACTIVE ---
    // Restore the original "Recommended / Zero Upcharge" layout
    if (!isFilterActive) {
      renderGroupedGripBuckets(window.__gripBuckets);
      updateShowAllGripsButton(); // Show the "Show All" button if sections are collapsed
      return;
    }

    // --- SCENARIO 2: FILTERS ACTIVE ---
    // 1. Flatten the buckets so we can search through EVERYTHING
    const allGrips = [
      ...(window.__gripBuckets.recommended || []),
      ...(window.__gripBuckets.zeroUpcharge || []),
      ...(window.__gripBuckets.others || [])
    ];

    // 2. Apply Filters
    const filtered = allGrips.filter(grip => {
      // Check Brand/Vendor
      const matchesVendor = (selectedVendor === "__all__" || selectedVendor === "") || 
                            grip.vendor === selectedVendor;
      
      // Check Search Text
      const matchesSearch = !searchText || 
                            (grip.productTitle && grip.productTitle.toLowerCase().includes(searchText)) || 
                            (grip.vendor && grip.vendor.toLowerCase().includes(searchText));

      return matchesVendor && matchesSearch;
    });

    // 3. Render "Search Results" Mode
    const container = document.getElementById('grip-results');
    container.innerHTML = ''; // Clear current view

    if (filtered.length > 0) {
      // Reuse renderGripSection to keep styling consistent, but don't collapse it
      renderGripSection(`All Grips`, filtered, false);
    } else {
      container.innerHTML = '<div class="no-results" style="padding: 20px; text-align: center;">No grips found matching your criteria.</div>';
    }

    // 4. Update Button Visibility
    // This effectively hides the "Show All" button while searching, which is good UX
    updateShowAllGripsButton();
  };

  // Listen for dropdown changes
  vendorSelect.addEventListener("change", handleFilter);

  // Listen for typing in the search box
  searchInput.addEventListener("input", handleFilter);
}


function initGripDrawer(buckets) {
  const drawer = document.getElementById("grip-drawer");
  if (!drawer) return;

  // 1. Accordion Logic (Info Toggles)
  // We use a named function to prevent duplicate listeners if init is called twice
  const handleAccordionClick = e => {
    const toggle = e.target.closest(".nbn-info-toggle");
    if (!toggle) return;
    e.stopPropagation();
    e.preventDefault();
    const accordion = toggle.closest(".nbn-info-accordion");
    accordion.classList.toggle("open");
  };
  
  // Clean up old listener before adding (good practice)
  document.removeEventListener("click", handleAccordionClick);
  document.addEventListener("click", handleAccordionClick);

  // 2. Close Logic
  document.getElementById("close-grip-drawer")
    ?.addEventListener("click", () => drawer.classList.remove("active"));

  // 3. Store Buckets Globally 
  // We store the whole bucket object so filters can access specific sections if needed
  window.__gripBuckets = buckets;

  // 4. Flatten all grips for the Brand Filter
  // Filters usually need a single list of all unique brands
  const allGripsFlat = [
    ...buckets.recommended, 
    ...buckets.zeroUpcharge, 
    ...buckets.others
  ];
  
  populateGripBrandFilter(allGripsFlat);

  // 5. Render the grouped UI
  // Instead of a flat list, we render the sections
  renderGroupedGripBuckets(buckets);

  // 6. Bind UI filters
  bindGripFilters();

  // 7. 🔥 BIND THE SHOW ALL BUTTON HERE
  bindShowAllGripsButton();

  // 8. Open Drawer Listeners
  document.querySelectorAll("#open-grip-drawer, #open-grip-drawer-btn").forEach(btn =>
    btn.addEventListener("click", (e) => {
      drawer.classList.add("active");
    })
  );
}

/**
 * Calculates price after fixed discount and returns formatted HTML
 * @param {number} basePrice - The raw price (e.g., 50.00)
 * @param {number} discountAmount - The fixed £ to subtract (e.g., 35)
 * @param {boolean} isZeroUpcharge - The product's zeroUpcharge flag
 * @param {string} unit - 'shaft' or 'grip'
 */
// function getPriceDisplayHTML(basePrice, discountAmount, isZeroUpcharge, unit) {
//     // Simple subtraction for fixed amounts
//     const finalPrice = Math.max(0, basePrice - (discountAmount || 0));

//     if (normalizeBool(isZeroUpcharge) || finalPrice <= 0) {
//         return `<div class="price price-zero">Zero Upcharge</div>`;
//     } else {
//         // toFixed(2) ensures it still looks like £15.00
//         return `<div class="price Math-min">+${theme.currencySymbol}${finalPrice.toFixed(2)}/${unit}</div>`;
//     }
// }

/**
 * @param {number|string} shaftPrice - Price from GraphQL (already converted/rounded by Shopify)
 * @param {number} discountBase - Discount in GBP (e.g., 35)
 * @param {boolean} isZeroUpcharge - Metafield check
 * @param {string} unit - Label (e.g., "shaft")
 */
function getPriceDisplayHTML(shaftPrice, discountBase, isZeroUpcharge, unit = "shaft") {
    const { rate = 1.0, active = 'GBP' } = Shopify.currency || {};
    const marketFee = (active === 'GBP') ? 1.0 : 1.02; // Accounts for the 2% fee in your Market settings

    // 1. Normalize input to decimal (not cents) to make raw math easier
    let currentPrice = parseFloat(shaftPrice);
    
    // 2. Convert the Discount to the current Market currency
    // GBP Discount * Exchange Rate * 2% Fee
    const convertedDiscount = Number(discountBase) * parseFloat(rate) * marketFee;

    // 3. Subtract from the already-rounded price (raw math)
    const finalPrice = Math.max(0, currentPrice - convertedDiscount);

    if (isZeroUpcharge || finalPrice <= 0) {
        return `<div class="price price-zero">Zero Upcharge</div>`;
    }

    // 4. Formatting - Removed the applyMarketRounding call here
    
    // Using Intl.NumberFormat to force 2 decimal places regardless of currency settings
    const formattedPrice = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: active,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(finalPrice);

    return `<div class="price">+${formattedPrice}/${unit}</div>`;
}

function renderGripProduct(grip, container) {
  const v = grip.variants[0];
  const el = document.createElement("div");
  
  // Clean up class logic: Use 'current-selected' as the primary state class
  el.className = "option_product";
  el.dataset.vendor = grip.vendor;

  // --- 1. INITIAL HIGHLIGHT CHECK ---
  // Ensure the product stays highlighted if the drawer is re-rendered
  if (window.__selectedGrip && window.__selectedGrip.productId === grip.productId) {
    el.classList.add('current-selected');
  }

  // Inside your grip loop/render function
  const gripPrice = Math.min(...grip.variants.map(v => v.price));
  const gripDiscount = currentClubConfig?.grip_discount_amount || 0;
  el.innerHTML = `
    <div class="option">
      <div class="option_head">
        <h4>${grip.short_title || grip.productTitle}</h4>
        ${getPriceDisplayHTML(gripPrice, gripDiscount, grip.zeroUpcharge, 'grip')}        
      </div>
      <div class="option_img">
        <img src="${getProductImageGrip(grip)}" loading="lazy">
      </div>
    </div>
  `;

  el.addEventListener('click', () => {
    // --- 2. UPDATE VISUAL SELECTION STATE ---
    // We target the entire results container to clear selection across ALL sections (Recommended/Others)
    document.querySelectorAll('#grip-results .option_product').forEach(item => {
      item.classList.remove('current-selected');
    });
    
    // Add class to the clicked element
    el.classList.add('current-selected');

    const variant = grip.variants.find(v => v.available) || grip.variants[0];
    const summary = buildShaftOptionSummary(variant);

    // Update Global State
    window.__selectedGrip = {
      productId: grip.productId,
      productTitle: grip.productTitle,
      variantId: variant.variantId,
      price: Number(variant.price || 0),
      featuredImage: grip.featuredImage,
      vendor: grip.vendor,
      ...summary,
      product: grip,
      variant: variant
    };

    // --- 3. UI UPDATES ---
    updateSelectedGripLabel(window.__selectedGrip);
    renderSelectedGripSummary(window.__selectedGrip);
    
    // Renders the size/color radios for the specific grip chosen
    renderGripVariantRadios(grip);

    updateBuildPrice();
    updateGripPriceUI();

    // Close drawer and show the "Change Grip" button
    document.getElementById("grip-drawer")?.classList.remove("active");
    const openBtn = document.getElementById("open-grip-drawer");
    if (openBtn) {
      openBtn.style.display = 'block';
    }
  });

  container.appendChild(el);

  // Remove error state if selection is made
  const configStep = document.querySelector("#grip-step .gd-config");
  if (configStep) configStep.classList.remove('has-error');
}

function updateSelectedGripLabel(grip) {
  // console.log('updateSelectedGripLabel grip',grip)
  const el = document.getElementById("selected-grip-name");
  if (!el || !grip) return;

  el.innerHTML = `
    ${grip.productTitle}
    <br>
    <div class="shaft-meta">
      <span class="shaft-meta-label">${grip.optionLabel || ''}</span><br>
      <strong class="shaft-meta-value">${grip.optionValue || ''}</strong>
    </div>
  `;

  // 1. Manually remove the error class from the grip button
  const gripBtn = document.querySelector('#grip-step .gd-config');;
  if (gripBtn) {
      gripBtn.classList.remove('has-error');
  }

  // 2. Refresh the order button
  if (typeof updateOrderButtonState === 'function') {
      updateOrderButtonState();
  }
}

function bindGripOptionEvents() {
  const logoToggle = document.getElementById("grip-logo-toggle");
  const tapeSelect = document.getElementById("grip-tape-select");

  if (logoToggle) {
    logoToggle.addEventListener("change", e => {
      window.__selectedGripOptions.logoOrientation =
        e.target.checked ? "down" : "up";

      // console.log("Grip logo:", window.__selectedGripOptions.logoOrientation);
    });
  }

  if (tapeSelect) {
    tapeSelect.addEventListener("change", e => {
      window.__selectedGripOptions.gripTape = e.target.value;

      // console.log("Grip tape:", window.__selectedGripOptions.gripTape);
    });
  }

  bindLogoOrientationToggle();
}

function renderGripVariantRadios(product) {
  if (!product || !product.variants?.length) return;

  renderVariantRadios({
    variants: product.variants,
    selectedVariant: window.__selectedGrip?.variant,
    containerId: "grip-variant-options",
    onChange: v => {
      window.__selectedGrip.variant = v;
      window.__selectedGrip.variantId = v.variantId;
      window.__selectedGrip.price = Number(v.price || 0);

      const summary = buildShaftOptionSummary(v);
      window.__selectedGrip.optionLabel = summary.optionLabel;
      window.__selectedGrip.optionValue = summary.optionValue;

      updateSelectedGripLabel(window.__selectedGrip);
      updateBuildPrice();
    }
  });
}


function renderSelectedGripSummary(grip) {
  if (!grip) return;

  const container = document.querySelector("#grip-step .js-set-selected-Grip");
  if (!container) return;

  // console.log('selcted grip',grip)
  // Inside your grip loop/render function
  const gripPrice = Math.min(...grip.product.variants.map(v => v.price));
  const gripDiscount = currentClubConfig?.grip_discount_amount || 0;
    container.innerHTML = `
      <div class="nbn-step-card">
        <div class="nbn-step-right">

          <div class="nbn-grip-price">
            ${getPriceDisplayHTML(gripPrice, gripDiscount, grip.zeroUpcharge, 'grip')}
          </div>
          <div class="nbn-grip-image">
            <img
              src="${getProductImageGrip(grip.product)}"
              alt="${grip.productTitle}"
              loading="lazy"
              width="420"
            />
          </div>

          <!-- GRIP VARIANT OPTIONS -->
          <div id="grip-variant-options" class="nbn-variant-options"></div>

          <!-- LOGO ORIENTATION -->
          <div class="nbn-grip-logo">
            <div class="nbn-advanced">
              <div class="gd-toggle">
                <button class="gd-toggle-btn" data-logoorientation="Up" aria-pressed="true">Logo Up</button>
                <label class="gd-switch" aria-hidden="true">
                  <input type="checkbox" class="gd-switch-input">
                  <span class="gd-switch-slider"></span>
                </label>
                <button class="gd-toggle-btn" data-logoorientation="Down" aria-pressed="false">Logo Down</button>
              </div>
          </div>
          

          <!-- GRIP TAPE -->
          <div class="nbn-grip-tape nbn-custom-select">
            <label for="grip-tape-select">Grip Tape</label>

            <select id="grip-tape-select">
              <option value="1 Layer (Standard)" selected>1 Layer (Standard)</option>
              <option value="2 Layers">2 Layers</option>
              <option value="3 Layers">3 Layers</option>
              <option value="4 Layers">4 Layers</option>
            </select>
          </div>
          </div>

        </div>
      </div>
    `;

  bindGripOptionEvents();
  bindLogoOrientationToggle();   // ← ADD THIS

}


/************** 
 * Grips Helper Ends
 * **************
 */


// ========== All Helper Ends ==========

// ========== USAGE EXAMPLES ==========
window.__selectedGrip = null;
window.__selectedGripOptions = {
  logoOrientation: "up",        // up | down
  gripTape: "1 Layer (Standard)"
};


function normalize(v) {
  return (v || '').toString().trim().toLowerCase();
}

function normalizeHand(v) {
  return normalize(v).includes('left') ? 'left' : 'right';
}

function normalizeNumber(v) {
  return normalize(v).replace(/[^\d.]/g, '');
}


function normalizeHeadVariants(product) {
  return product.variants.map(v => ({
    id: v.id,
    available: v.available,
    price: Number(v.price),
    compare_at_price: v.compare_at_price ? Number(v.compare_at_price) : null,
    options: [v.option1, v.option2, v.option3].map(normalize)
  }));
}



function resolveOptionIndexes(product) {
  const opts = product?.options || [];

  let dexIndex = null;
  let loftIndex = null;
  let bounceIndex = null;

  opts.forEach((opt, i) => {
    const name = (opt || '').toLowerCase();

    if (/(dexter|hand)/.test(name)) dexIndex = i;
    if (/(loft|°)/.test(name)) loftIndex = i;
    if (/bounce/.test(name)) bounceIndex = i;
  });

  return {
    dexIndex,
    loftIndex,
    bounceIndex
  };
}


function sortLoftOptions() {
  const container = document.querySelector('.gd-loft-options');
  if (!container) return;

  // 1. Get all buttons as an Array
  const buttons = Array.from(container.querySelectorAll('.gd-loft-btn'));

  // 2. Sort the array based on the data-loft attribute
  buttons.sort((a, b) => {
    const loftA = parseFloat(a.getAttribute('data-loft'));
    const loftB = parseFloat(b.getAttribute('data-loft'));
    return loftA - loftB;
  });

  // 3. Append them back to the container in the new order
  buttons.forEach(btn => container.appendChild(btn));
}


function updateBuildPrice() {
  const head = window.__selectedHeadVariant;
  const shaft = window.__selectedShaft;
  const grip = window.__selectedGrip;
  var shaftMinPrice = shaft?.price || 0;
  
  // 1. Base Head Price (Never discounted)
  const base = Number(head?.price || 0) / 100; 

  const { rate = 1.0, active = 'GBP' } = Shopify.currency || {};
  const marketFee = (active === 'GBP') ? 1.0 : 1.02;

  // 1. Shaft Logic
  let shaftPrice = 0;
  if (shaft) {
    const isZeroUpcharge = JSON.parse(window.__selectedShaft.product.zeroUpcharge) === true;
    
    if (!isZeroUpcharge) {
      const rawShaftPrice = Number(shaftMinPrice || 0);
      const shaftDiscountBase = currentClubConfig?.shaft_discount_amount || 0;
      
      // Convert Discount: Base GBP * Rate * 2% Fee
      const convertedDiscount = shaftDiscountBase * rate * marketFee;
      
      // SUBTRACT ONLY: No rounding applied here
      shaftPrice = Math.max(0, rawShaftPrice - convertedDiscount);
    } else {
      shaftPrice = 0;
    }
  }

  // 2. Grip Logic
  let gripPrice = 0;  
  if (grip) {
    const isGripZeroUpcharge = JSON.parse(grip.product?.zeroUpcharge || "false") === true;
    
    if (!isGripZeroUpcharge) {
      const rawGripPrice = Number(grip.price || 0);
      const gripDiscountBase = currentClubConfig?.grip_discount_amount || 0;
      
      // Convert Discount: Base GBP * Rate * 2% Fee
      const convertedGripDiscount = gripDiscountBase * rate * marketFee;
      
      // SUBTRACT ONLY: No rounding applied here
      gripPrice = Math.max(0, rawGripPrice - convertedGripDiscount);
    } else {
      gripPrice = 0;
    }
  }

  // Log with 2 decimals to verify precision
  // console.log('Final Calculated Prices:', { 
  //   shaftPrice: shaftPrice.toFixed(2), 
  //   gripPrice: gripPrice.toFixed(2) 
  // });
  

  // 4. Spine Alignment (Standard upcharge)
  const spinePrice = (window.spine_alignment?.variants[0]?.price || 0) / 100;
  const spine = window.__spineAlignment ? spinePrice : 0;

  const ferrule = window.__ironAdjustments?.ferruleVariant;
  let ferrulePrice = ferrule ? Number(ferrule.price || 0) / 100 : 0;
   if (ferrule && ferrule.title != "Standard") {
    ferrulePrice = Number(ferrule.price || 0) / 100;
  }

  // 5. Calculate Final Total
  const total = base + shaftPrice + gripPrice + spine + ferrulePrice;

  // 6. Update UI
  const priceEl = document.querySelector('[data-product-price]');
  const unitEl = document.querySelector('.unit-price span');
  const formattedTotal = `${theme.currencySymbol}${total.toFixed(2)}`;
  
  if (priceEl) priceEl.textContent = formattedTotal;
  if (unitEl) unitEl.textContent = formattedTotal;

  // 7. Expose Build Object
  window.__currentBuild = {
    headVariant: head,
    shaftVariant: shaft,
    grip: grip,
    spine,
    ferrule,
    headBasePrice: base,
    shaftFinalPrice: shaftPrice,
    gripFinalPrice: gripPrice,
    total
  };
}




function updateDisplayedPrice(basePrice, shaftPrice = 0) {
  const total = Number(basePrice || 0) + Number(shaftPrice || 0);

  const amountEl = document.querySelector('[data-product-price]');
  const unitPriceEl = document.querySelector('.unit-price span');

  if (amountEl) {
    amountEl.textContent = `${theme.currencySymbol}${total.toFixed(2)}`;
  }

  if (unitPriceEl) {
    unitPriceEl.textContent = `${theme.currencySymbol}${total.toFixed(2)}`;
  }
}

function getFullVariantById(id) {
  return window.currentProduct?.variants?.find(v => Number(v.id) === Number(id)) || null;
}

function normalizeHand(v) {
  return (v || '')
    .toString()
    .toLowerCase()
    .replace(' hand', '')
    .trim();
}

function normalizeLoft(v) {
  return (v || "")
    .toString()
    .replace(/[°˚]/g, "")   // remove both degree symbols
    .replace(/\s+/g, "")
    .toLowerCase();
}



function initHeadVariantSelection({ product, variants, dexIndex, loftIndex, bounceIndex }) {
  const root = document.querySelector(`.gd-config[data-product-id="${product.id}"]`);
  if (!root) return;

  // const form = document.querySelector(`#gd-product-form-${product.id}`);
  const form = document.querySelector(`.gd-product-form`);
  const inputVariant = form?.querySelector('input[name="id"]');
  const switchInput = root.querySelector('.gd-switch-input');

  const handBtns   = [...root.querySelectorAll('[data-hand]')];
  const loftBtns   = [...root.querySelectorAll('[data-loft]')];
  const bounceBtns = [...root.querySelectorAll('[data-bounce]')];

  const norm = v => (v || '').toString().trim().toLowerCase();
  const normalizeHand = v => norm(v).startsWith('l') ? 'left' : 'right';

  // HELPER: Find a valid variant based on current selections
  // If no perfect match, it finds the closest available one for that hand
  function findBestVariant(hand, loft, bounce) {
    // 1. Try for exact match
    let match = variants.find(v => 
      normalizeHand(v.options[dexIndex]) === hand &&
      norm(v.options[loftIndex]) === norm(loft) &&
      norm(v.options[bounceIndex]) === norm(bounce)
    );

    // 2. If no exact match, try matching hand and loft
    if (!match) {
      match = variants.find(v => 
        normalizeHand(v.options[dexIndex]) === hand &&
        norm(v.options[loftIndex]) === norm(loft)
      );
    }

    // 3. Fallback to just the hand
    if (!match) {
      match = variants.find(v => normalizeHand(v.options[dexIndex]) === hand);
    }

    return match || variants[0];
  }

  function syncUI(variant) {
    if (!variant) return;

    // Update Toggle for Hand
    const hand = normalizeHand(variant.options[dexIndex]);
    switchInput.checked = (hand === 'left');
    
    // Update Aria-Pressed for Hand Buttons (Visual Only)
    handBtns.forEach(btn => {
      btn.setAttribute('aria-pressed', btn.dataset.hand === hand);
    });

    // Update Loft Buttons
    const currentLoft = norm(variant.options[loftIndex]);
    loftBtns.forEach(btn => {
      const isSelected = norm(btn.dataset.loft) === currentLoft;
      btn.setAttribute('aria-checked', isSelected);
      
      // Check if this loft even exists for the current hand
      const exists = variants.some(v => 
        normalizeHand(v.options[dexIndex]) === hand && 
        norm(v.options[loftIndex]) === norm(btn.dataset.loft)
      );
      btn.style.display = exists ? 'block' : 'none'; // Hide non-existent options
    });

    // Update Bounce Buttons
    const currentBounce = norm(variant.options[bounceIndex]);
    bounceBtns.forEach(btn => {
      const isSelected = norm(btn.dataset.bounce) === currentBounce;
      btn.setAttribute('aria-checked', isSelected);

      // Check if this bounce exists for current hand + current loft
      const exists = variants.some(v => 
        normalizeHand(v.options[dexIndex]) === hand && 
        norm(v.options[loftIndex]) === currentLoft &&
        norm(v.options[bounceIndex]) === norm(btn.dataset.bounce)
      );
      btn.toggleAttribute('disabled', !exists);
      btn.style.display = exists ? 'block' : 'none';
    });

    // Set Hidden Input
    if (inputVariant) inputVariant.value = variant.id;
    window.__selectedHeadVariant = variant;
    
    // Trigger price update if function exists
    if (typeof updateBuildPrice === 'function') updateBuildPrice();
  }

  // --- Event Listeners ---

  switchInput.addEventListener('change', () => {
    const newHand = switchInput.checked ? 'left' : 'right';
    const activeLoft = loftBtns.find(b => b.getAttribute('aria-checked') === 'true')?.dataset.loft;
    const activeBounce = bounceBtns.find(b => b.getAttribute('aria-checked') === 'true')?.dataset.bounce;
    
    const v = findBestVariant(newHand, activeLoft, activeBounce);
    syncUI(v);
  });

  loftBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const hand = switchInput.checked ? 'left' : 'right';
      const v = findBestVariant(hand, btn.dataset.loft, null);
      syncUI(v);
    });
  });

  bounceBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const hand = switchInput.checked ? 'left' : 'right';
      const activeLoft = loftBtns.find(b => b.getAttribute('aria-checked') === 'true')?.dataset.loft;
      const v = findBestVariant(hand, activeLoft, btn.dataset.bounce);
      syncUI(v);
    });
  });

  // Initialize with first variant
  syncUI(variants[0]);
}




function normalizeProductTypeLabel(label) {
  if (!label || typeof label !== 'string') return label;

  let s = label.trim();
  s = s.replace(/\s+/g, ' ');
  s = s.replace(/Shafts$/i, 'Shaft');
  s = s.replace(/shafts$/i, 'Shaft'); // defensive

  return s;
}

function populateFlightSpinFilters(groupedProducts) {
  const flightSelect = document.getElementById('filter-flight');
  const spinSelect   = document.getElementById('filter-spin');

  if (!flightSelect || !spinSelect) return;

  // Reset (keep placeholder option)
  flightSelect.length = 1;
  spinSelect.length = 1;

  const flights = new Set();
  const spins   = new Set();

  groupedProducts.forEach(p => {
    if (p.ball_flight) flights.add(p.ball_flight);
    if (p.ball_spin) spins.add(p.ball_spin);
  });

  [...flights].sort().forEach(val => {
    const o = document.createElement('option');
    o.value = val;
    o.textContent = val;
    flightSelect.appendChild(o);
  });

  [...spins].sort().forEach(val => {
    const o = document.createElement('option');
    o.value = val;
    o.textContent = val;
    spinSelect.appendChild(o);
  });
}

function buildShaftOptionSummary(variant) {
  if (!variant || !variant.options) {
    return { optionLabel: "", optionValue: "" };
  }

  const entries = Object.entries(variant.options);

  return {
    optionLabel: entries.map(([k]) =>
      k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    ).join(" / "),
    optionValue: entries.map(([, v]) => v).join(" / ")
  };
}


function buildVariantOptionSummary(options = {}) {
  const entries = Object.entries(options);

  if (!entries.length) {
    return {
      label: "",
      value: ""
    };
  }

  const label = entries
    .map(([key]) =>
      key
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase())
    )
    .join(" / ");

  const value = entries
    .map(([, val]) => val)
    .join(" / ");

  return { label, value };
}


async function initShaftFlow() {
  const headType = currentProduct.type;
  const cfg = CONFIG?.clubs_head_type?.[headType];

  if (!cfg) return;

  const types = [
    ...new Set(
      cfg.shafts_to_pull.map(normalizeProductTypeLabel)
    )
  ];

  // Find current brand
  const brand = window.META_BRANDS?.find(
    b =>
      String(b.title || '').trim().toLowerCase() ===
      String(currentProduct.vendor || '').trim().toLowerCase()
  );

  // Brand configuration:
  // Which club types are allowed to receive
  // this brand's additional stock shafts?
  const additionalProductTypes =
    brand?.additional_product_type || [];

  const shouldIncludeAdditionalShafts =
    additionalProductTypes.some(
      type =>
        String(type || '').trim().toLowerCase() ===
        String(currentProduct.type || '').trim().toLowerCase()
    );

  // Get the configured additional shaft IDs
  const additionalShaftIds =
    shouldIncludeAdditionalShafts
      ? (
          brand?.zero_upcharge_additional_shafts
            ?.map(shaft => shaft.id)
            .filter(Boolean) || []
        )
      : [];

  console.log('--------------------------------');
  console.log('Shaft configuration');
  console.log('Brand:', brand?.title);
  console.log('Club Type:', currentProduct.type);
  console.log(
    'Additional Product Types:',
    additionalProductTypes
  );
  console.log(
    'Include Additional Shafts:',
    shouldIncludeAdditionalShafts
  );
  console.log(
    'Additional Shaft IDs:',
    additionalShaftIds
  );
  console.log('--------------------------------');

  const shafts = await fetchShaftsByTypes(types, {
    pageSize: 50,
    variantFirst: 250,
    additionalShaftIds
  });

  console.log('FINAL SHAFTS', shafts);

  const flatVariants = flattenShafts(shafts);

  const groupedProducts =
    groupShaftsByProduct(
      flatVariants,
      window.currentProduct
    );

  initPreSelectedShaft(groupedProducts);
  initShaftDrawer(groupedProducts);

  if (window.__selectedShaft) {
    updateSelectedShaftLabel(window.__selectedShaft);
    renderSelectedShaftSummary(window.__selectedShaft);

    // 🔥 Render variants for selected shaft
    const product = groupedProducts.find(
      p => p.productId === window.__selectedShaft.productId
    );

    if (product) {
      renderShaftVariantRadios(window.__selectedShaft.product);
    }
  }
  updateDisplayedPrice(window.__baseProductPrice, window.__selectedShaft?.price || 0);
  updateBuildPrice();

  if (window.__selectedShaft) {
  document
    .querySelectorAll('#open-shaft-drawer-btn')
    .forEach(btn =>{
      btn.style.display='none';
    });
    document.querySelector("button#open-shaft-drawer").style.display='block';
  }
  else{
    document
    .querySelectorAll('#open-shaft-drawer-btn')
    .forEach(btn =>{
      btn.style.display='block';
    });
    document.querySelector("button#open-shaft-drawer").style.display='none';
  }

    
}


function renderShaftVariantRadios(product) {
  // console.log('shft varians',product.variants)
   renderVariantRadios({
      variants: product.variants,
      selectedVariant: window.__selectedShaft.variant,
      containerId: "shaft-variant-options",
      onChange: v => {
        // console.log('v.variantId',v.variantId)
        window.__selectedShaft.variant = v;
        window.__selectedShaft.variantId=v.variantId;
        const summary = buildShaftOptionSummary(v);
        window.__selectedShaft.optionLabel = summary.optionLabel;
        window.__selectedShaft.optionValue = summary.optionValue;
        window.__selectedShaft.price = v.price;

        updateSelectedShaftLabel(window.__selectedShaft);
        updateBuildPrice();
      }
    });

}




function renderShaftModelRadios(product) {
  const container = document.getElementById("shaft-variant-options");
  const variants = product.variants;
  const flex = window.__selectedShaft.flex;

  const models = [...new Set(
    variants.filter(v => v.flex === flex).map(v => v.model)
  )];

  container.insertAdjacentHTML("beforeend", `
    <div class="variant-group">
      <label>Weight</label>
      <div class="variant-radios" id="shaft-model-options"></div>
    </div>
  `);

  const modelWrap = container.querySelector("#shaft-model-options");

  models.forEach(model => {
    const v = variants.find(v => v.flex === flex && v.model === model);

    modelWrap.insertAdjacentHTML("beforeend", `
      <label class="iron-flex-option radio-option ${v.available ? "" : "disabled"}">
        <input type="radio" name="shaft-model" value="${model}"
          ${window.__selectedShaft.model === model ? "checked" : ""}
          ${v.available ? "" : "disabled"}>
        <span>${model}</span>
      </label>
    `);
  });
}


function renderGroupedShaftProduct(product, container) {
  const el = document.createElement('div');
      el.className = 'option_product';
      // console.log('product.short title',product.short_title)

      // --- 1. INITIAL HIGHLIGHT CHECK ---
    // If this product is already the selected one, add the class immediately
    if (window.__selectedShaft && window.__selectedShaft.productId === product.productId) {
      el.classList.add('current-selected');
    }
    // Inside your shaft loop/render function
    // const shaftPrice = Math.min(...product.variants.map(v => v.price));
    const shaftPrice = product.variants[0].price;
    const shaftDiscount = currentClubConfig?.shaft_discount_amount || 0;
    // console.log(product.productTitle,'shaftPrice',shaftPrice,'shaftDiscount',shaftDiscount ,getPriceDisplayHTML(shaftPrice, shaftDiscount, product.zeroUpcharge, 'shaft'))

      el.innerHTML = `
        <div class="option">
          <div class="option_head">
            <h4>${product.short_title || product.productTitle}</h4>
            ${getPriceDisplayHTML(shaftPrice, shaftDiscount, product.zeroUpcharge, 'shaft')}
          </div>

          <div class="option_img">
            <img src="${getProductImage(product)}" loading="lazy">
          </div>
        </div>
      `;

      el.addEventListener("click", () => {
        // console.log('product',product);

      // --- 2. UPDATE VISUAL SELECTION STATE ---
      // Remove class from all siblings in this container
      // console.log(container.querySelectorAll('.option_product'))
      document.querySelectorAll('#shaft-results .option_product').forEach(item => {
        item.classList.remove('current-selected');
      });
      // Add class to the clicked element
      el.classList.add('current-selected');
      
      const variant = product.variants.find(v => v.available) ||
        product.variants[0];

        window.__currentShaftProduct = product; // 🔑 ADD THIS

        const { label, value } = buildVariantOptionSummary(variant.options);
        const summary = buildShaftOptionSummary(variant);
        window.__selectedShaft = {
          productId: product.productId,
          productTitle: product.productTitle,
          variantId: variant.variantId,
          flex: variant.flex,
          model: variant.model,
          price: Number(variant.price||0),
          featuredImage: product.featuredImage,
          shortDescription: product.shortDescription,
          short_title: product.short_title,
          ...summary,
          product:product,
          variant:variant
        };

      console.log('1446 window.__selectedShaft',window.__selectedShaft)
      updateSelectedShaftLabel(window.__selectedShaft);
      renderSelectedShaftSummary(window.__selectedShaft);

      // 🔥 THIS IS THE KEY CALL
      // console.log('1476 product',product)
      renderShaftVariantRadios(window.__selectedShaft.product);

      updateBuildPrice();

      document
        .getElementById("shaft-drawer")
        ?.classList.remove("active");
        document.querySelector("button#open-shaft-drawer").style.display='block';
  });

  container.appendChild(el);

  document.querySelector("#shaft-step .gd-config").classList.remove('has-error');
}


function renderGroupedShaftBuckets(buckets) {
  const container = document.getElementById('shaft-results');
  container.innerHTML = '';

  const recommendedList = buckets.preSelected.concat(buckets.recommended);

  // 1. Render Recommended
  renderSection(
    'Recommended for You',
    recommendedList
  );

  // 2. Render Zero Upcharge
  renderSection(
    'Zero Upcharge Shafts',
    buckets.zeroUpcharge
  );

  // LOGIC: Check if we have anything rendered in the top two sections
  const hasPriorityShafts = recommendedList.length > 0 || buckets.zeroUpcharge.length > 0;
  
  // If no priority shafts exist, set collapsible to false so "All Shafts" shows automatically
  const shouldCollapse = hasPriorityShafts ? true : false;

  // 3. Render All Shafts
  renderSection(
    'All Shafts',
    buckets.others,
    shouldCollapse
  );
}

function renderSection(title, products, collapsible = false) {
  if (!products || !products.length) return;

  const container = document.getElementById('shaft-results');

  const section = document.createElement('div');
  section.className = 'shaft-section';

  // Keeping your exact HTML structure
  section.innerHTML = `
    <h3 class="shaft-section-title">${title}</h3>
    <div class="shaft-section-list"></div>
  `;

  const list = section.querySelector('.shaft-section-list');
  products.forEach(p => renderGroupedShaftProduct(p, list));

  if (collapsible) {
    section.classList.add('is-collapsed');
    
    // Create the "Show All" toggle button separately to keep your innerHTML clean
    //No need to append show all buttn
    // const showAllBtn = document.createElement('button');
    // showAllBtn.type = 'button';
    // showAllBtn.className = 'gd-show-all-shafts';
    // showAllBtn.textContent = 'Show All Shafts';
    
    // showAllBtn.addEventListener('click', () => {
    //   section.classList.remove('is-collapsed');
    //   showAllBtn.remove(); // Remove button once expanded
    // });

    // section.appendChild(showAllBtn);
  }

  container.appendChild(section);
}


function initShaftDrawer(groupedProducts) {
  const drawer = document.getElementById('shaft-drawer');
  if (!drawer) return;

  // open / close handlers (unchanged)
  document
    .querySelectorAll('#open-shaft-drawer, #open-shaft-drawer-btn')
    .forEach(btn =>
      btn.addEventListener('click', () => drawer.classList.add('active'))
    );



  document.addEventListener("click", e => {
    const toggle = e.target.closest(".nbn-info-toggle");
    if (!toggle) return;

    // 🔥 Prevent drawer from closing
    e.stopPropagation();
    e.preventDefault();

    const accordion = toggle.closest(".nbn-info-accordion");
    accordion.classList.toggle("open");
  });


  document.getElementById('close-shaft-drawer')
    ?.addEventListener('click', () => drawer.classList.remove('active'));

  populateGroupedFilters(groupedProducts);
  populateFlexFilterFromGroups(groupedProducts);
  populateFlightSpinFilters(groupedProducts);

  // 🔑 build buckets ONCE
  window.__shaftBuckets = buildInitialShaftOrder(groupedProducts);

  // ✅ NEW: preselect shaft on page load
  initPreSelectedShaft(groupedProducts);

  bindGroupedShaftFilters();

  // initial render
  renderGroupedShaftBuckets(window.__shaftBuckets);
  bindShowAllShaftsButton();
}


function updateSelectedShaftLabel(shaft) {
  if (!shaft) return;

  const el = document.getElementById("selected-shaft-name");
  if (!el) return;
  
  el.innerHTML = `
  <div class="shaft-title">${shaft.productTitle}</div>
  
  <div class="shaft-meta">
  <span class="shaft-meta-label">${shaft.optionLabel || ''}</span><br>
  <strong class="shaft-meta-value">${shaft.optionValue || ''}</strong>
  </div>
  `;
  
  // 1. Manually remove the error class from the grip button
  // console.log('updateSelectedShaftLabel shaft',shaft,shaft.optionLabel,shaft.optionValue)
  const gripBtn = document.querySelector('#shaft-step .gd-config');
  if (gripBtn) {
      gripBtn.classList.remove('has-error');
  }

  // 2. Refresh the order button
  if (typeof updateOrderButtonState === 'function') {
      updateOrderButtonState();
  }
}


function bindShowAllShaftsButton() {
  const btn = document.getElementById('show-all-shafts-btn');
  if (!btn) return;

  btn.addEventListener('click', () => {
    expandAllShaftSections();
    updateShowAllShaftsButton();
  });

  // initial sync
  updateShowAllShaftsButton();
}

function expandAllShaftSections() {
  document
    .querySelectorAll('.shaft-section.is-collapsed')
    .forEach(section => section.classList.remove('is-collapsed'));
}

function hasActiveShaftFilters() {
  const search = document.getElementById("shaft-search")?.value || "";
  const brand  = document.getElementById("filter-brand")?.value || "";
  const flex   = document.getElementById("filter-flex")?.value || "";
  const flight = document.getElementById("filter-flight")?.value || "";
  const spin   = document.getElementById("filter-spin")?.value || "";

  return !!(search || brand || flex || flight || spin);
}

function hasCollapsedSections() {
  return !!document.querySelector('.shaft-section.is-collapsed');
}

function updateShowAllShaftsButton() {
  const btn = document.getElementById('show-all-shafts-btn');
  if (!btn) return;

  const show = !hasActiveShaftFilters() && hasCollapsedSections();
  btn.style.display = show ? 'block' : 'none';
}



function applyGroupedShaftFilters() {
  const search = document.getElementById("shaft-search")?.value.toLowerCase() || "";
  const brand  = document.getElementById("filter-brand")?.value || "";
  const flex   = document.getElementById("filter-flex")?.value || "";
  const flight = document.getElementById("filter-flight")?.value || "";
  const spin   = document.getElementById("filter-spin")?.value || "";

  const hasActiveFilter = !!(search || brand || flex || flight || spin);

  const filterFn = list =>
    list
      .map(p => {
        if (brand && p.brand !== brand) return null;
        if (flight && p.ball_flight !== flight) return null;
        if (spin && p.ball_spin !== spin) return null;

        const variants = p.variants.filter(v =>
          (!flex || v.flexGroup === flex) &&
          (!search || p.productTitle.toLowerCase().includes(search))
        );

        return variants.length ? { ...p, variants } : null;
      })
      .filter(Boolean);

  renderGroupedShaftBuckets({
    preSelected: filterFn(window.__shaftBuckets.preSelected),
    recommended: filterFn(window.__shaftBuckets.recommended),
    zeroUpcharge: filterFn(window.__shaftBuckets.zeroUpcharge),
    others: filterFn(window.__shaftBuckets.others)
  });

    // 🔥 KEY FIX: auto-expand when filtering
    // auto-expand when filtering
    if (hasActiveFilter) {
      expandAllShaftSections();
    }

    updateShowAllShaftsButton();
}


function bindGroupedShaftFilters() {
  [
    'shaft-search',
    'filter-brand',
    'filter-flex',
    'filter-flight',
    'filter-spin'
  ].forEach(id => {
    const el = document.getElementById(id);
    if (!el) return;

    const handler = () => {
      applyGroupedShaftFilters();
      updateShowAllShaftsButton();
      expandAllShaftSections();
    };

    el.addEventListener('input', handler);
    el.addEventListener('change', handler);
  });
}


function populateGroupedFilters(groupedProducts) {
  const brandSelect = document.getElementById('filter-brand');
  const flexSelect  = document.getElementById('filter-flex');

  if (!brandSelect || !flexSelect) return;

  // Reset (keep first placeholder option)
  brandSelect.length = 1;
  flexSelect.length = 1;

  // --- Brand (product-level) ---
  const brands = new Set();
  groupedProducts.forEach(p => {
    if (p.brand) brands.add(p.brand);
  });

  [...brands].sort().forEach(brand => {
    const o = document.createElement('option');
    o.value = brand;
    o.textContent = brand;
    brandSelect.appendChild(o);
  });

  // --- Flex (variant-level) ---
  const flexes = new Set();
  groupedProducts.forEach(p => {
    p.variants.forEach(v => {
      if (v.flexFilter) flexes.add(v.flexFilter);
    });
  });

  [...flexes].sort().forEach(flex => {
    const o = document.createElement('option');
    o.value = flex;
    o.textContent = flex.replace(/-/g, ' ');
    flexSelect.appendChild(o);
  });
}

function normalizeShaftProfile(value) {
  if (!value) return '';
  const v = String(value).toLowerCase();
  if (v.includes('.355')) return '.355 taper';
  if (v.includes('.370')) return '.370 parallel';
  return '';
}


// Shared head/shaft compatibility matrix — mirrors the iron rules.
// NOTE: normalizeShaftProfile() in THIS file returns '.355 taper' / '.370 parallel',
// not the bare '355' / '370' used in nbn-custom-irons.js. Do not copy comparisons across.
function isShaftProfileCompatible(activeProfile, shaftProfile, shaftMaterial) {
  if (!activeProfile) return true;   // head has no profile → no filtering
  if (!shaftProfile)  return true;   // shaft has no profile → pass through

  const material = (shaftMaterial || '').toLowerCase();

  // .355 head → Graphite pulls both, Steel restricted to .355
  if (activeProfile === '.355 taper') {
    if (material === 'graphite') return true;
    return shaftProfile === '.355 taper';
  }

  // .370 head → pulls everything
  if (activeProfile === '.370 parallel') return true;

  return shaftProfile === activeProfile;
}

function flattenShafts(shafts) {
  const flat = [];
  shafts.forEach(p => {
    (p.variants || []).forEach(v => {
      // console.log('p.shortDescription',p)
      const thumb = getShopifyImageUrl(p.featuredImage, { width: 280 });
      flat.push({
        productId: p.id,
        productTitle: p.title,
        variantTitle: v.title,
        productType: p.productType,
        featuredImage: thumb,
        variantId: v.id,
        vendor: p.vendor,
        available: p.availableForSale,
        price: Number(v.priceAmount||0),
        flex: v.flex || '',
        model: v.model || '',
        shaft_profile: p.shaft_profile || '',
        shortDescription: p.shortDescription || '',
        short_title: p.short_title || '',
        ball_spin: p.ball_spin || '',
        ball_flight: p.ball_flight || '',
        recommended: p.recommended || false,
        zeroUpcharge: p.zeroUpcharge || false,
        options:v.options,
        gripthumb:p.gripthumb,
        shaftThumb:p.shaftThumb,
        material:p.material,
      });
    });
  });
  return flat;
}

function groupShaftsByProduct(flatVariants, currentProduct) {
  const map = new Map();

  const productTypeLower = (currentProduct?.type || "").toLowerCase();
  const productTags = currentProduct?.tags || [];
  // 1. Get the Head Profile (t) from the current product context
  // Assuming currentProduct or h mapping corresponds to your h.headDiv logic
  const headProfile = currentProduct?.metafields?.shaft_profile || ""; 
  const isDrivingIron = currentProduct?.type?.toLowerCase().includes("driving iron") || 
                        currentProduct?.tags?.includes("driving-iron");

  const isWedge = productTypeLower.includes("wedge") || productTags.includes("wedge");

  const activeProfile = normalizeShaftProfile(headProfile);


  // console.log('flatVariants', flatVariants);
  // const filteredVariants = flatVariants;

  // 2. Apply the specific Driving Iron logic vs. Standard logic
  const filteredVariants = flatVariants.filter(v => {
    const shaftProfile = normalizeShaftProfile(v.shaft_profile);
    const shaftMaterial = (v.material || "").toLowerCase();
    const shaftType = v.productType || "";

    // console.log('shaftType',shaftType)

    // --- NEW: Wedge Logic ---
    return isShaftProfileCompatible(activeProfile, shaftProfile, shaftMaterial);

    // console.log('isDrivingIron',isDrivingIron,"shaftMaterial",shaftMaterial)
    if (isDrivingIron) {
      // Logic: Keep if (shaftProfile is null) OR (head is "370") OR (shaft is "355") OR (material is "graphite")
      return (
        !shaftProfile || 
        activeProfile === "370" || 
        shaftProfile === "355" || 
        shaftMaterial === "graphite"
      );
    }

    // Standard logic: Keep if profiles match (if an activeProfile exists)
    return activeProfile ? shaftProfile === activeProfile : true;
  });

  // 3. Grouping logic (kept as is)
  filteredVariants.forEach(v => {
    const key = v.productId;

    if (!map.has(key)) {
      map.set(key, {
        productId: v.productId,
        productTitle: v.productTitle,
        brand: v.brand || v.vendor,
        ball_flight: v.ball_flight || '',
        ball_spin: v.ball_spin || '',
        recommended: v.recommended || false,
        zeroUpcharge: v.zeroUpcharge || false,
        featuredImage: v.image || v.featuredImage || '',
        shortDescription: v.shortDescription || '',
        short_title: v.short_title || '',
        gripthumb: v.gripthumb,
        shaftThumb: v.shaftThumb,
        shaft_profile: v.shaft_profile || '',
        productType: v.productType || '',
        variants: [],
        material:v.material,
      });
    }

    map.get(key).variants.push({
      variantId: v.variantId,
      flexRaw: v.variantTitle,
      flexGroup: resolveFlexGroup(v.variantTitle),
      flex: v.flex,
      model: v.model,
      price: Number(v.price || 0),
      available: v.available,
      options: v.options,
      variantTitle:v.variantTitle
    });
  });

  return [...map.values()];
}

function populateFlexFilterFromGroups(groupedProducts) {
  const select = document.getElementById('filter-flex');
  if (!select) return;

  select.length = 1; // keep "All Flexes"

  const groups = new Set();

  groupedProducts.forEach(p => {
    p.variants.forEach(v => {
      if (v.flexGroup) groups.add(v.flexGroup);
    });
  });

  [...groups].forEach(group => {
    const o = document.createElement('option');
    o.value = group;
    o.textContent = group;
    select.appendChild(o);
  });
}

function buildLengthOptionsHtml(lengthConfig) {
  if (!lengthConfig) return '<option>No lengths available</option>';

  return lengthConfig.length_values
    .map(val => {
      const selected =
        val === lengthConfig.default_length ? 'selected' : '';
      return `<option ${selected}>${val}</option>`;
    })
    .join('');
}


function updateShaftPriceUI() {
  const el = document.querySelector('.nbn-shaft-price .price');
  if (!el || !window.__selectedShaft) return;

  
  if (JSON.parse(window.__selectedShaft.product?.zeroUpcharge) === true) {
    el.textContent = `+${theme.currencySymbol}0 / shaft`;
  } else {
    el.textContent = `+${theme.currencySymbol}${Number(window.__selectedShaft.price).toFixed(2)} / shaft`;
  }
}

function renderSelectedShaftSummary(shaft) {
  if (!shaft) return;

  const container = document.querySelector("#shaft-step .js-set-selected-Shaft");
  if (!container) return;

  // Inside your shaft loop/render function
const shaftPrice = shaft.product.variants[0].price;
const shaftDiscount = currentClubConfig?.shaft_discount_amount || 0;
  // console.log('selected shaft product',shaft.product)
  container.innerHTML = `
    <div class="nbn-step-card">
      <div class="nbn-step-right">
        <div class="nbn-shaft-price">
        ${getPriceDisplayHTML(shaftPrice, shaftDiscount, shaft.product.zeroUpcharge, 'shaft')}
        </div>
        <div class="nbn-shaft-image">
          <img src="${getProductImage(shaft.product)}" loading="lazy" width="420">
        </div>

        <!-- VARIANT OPTIONS -->
        <div id="shaft-variant-options" class="nbn-variant-options"></div>

        <div class="nbn-shaft-length nbn-custom-select">
          <label>Playing Length</label>
          <select id="shaft-length-select">
            ${buildLengthOptionsHtml(getLengthConfigForCurrentHead())}
          </select>
        </div>

        <!-- Staff-only: Swing Weight + Tipping (empty string for non-staff) -->
        ${buildStaffShaftSpecsHtml()}

        <!-- Advanced options injected here -->
        <div id="shaft-advanced-options"></div>

      </div>
    </div>
  `;

  const right = container.querySelector(".nbn-step-right");
  const adv = container.querySelector("#shaft-advanced-options");
  adv.innerHTML = "";
  renderAdapterDropdown(adv);
  renderIronAdjustments(adv);
  renderSpineAlignment(adv);

  // Staff-only fields were re-created by the innerHTML above; re-bind them.
  bindStaffShaftSpecs(container);

}

function renderIronAdjustments(container) {

  if (currentProduct?.type?.toLowerCase() !="wedge" && currentProduct?.type?.toLowerCase() !="driving iron") return;

  const ferruleVariants = (window.ferrule_product?.variants || []);
  const defaultFerruleImg = getShopifyImageUrl(window.ferrule_product.featured_image, {width:60});
  // console.log('ferruleVariants',ferruleVariants)
  const html = `
    <div class="nbn-advanced">
      <div class="nbn-shaft-length nbn-custom-select">
        <label>Ferrule <img src="${getShopifyImageUrl(window.ferrule_product.featured_image,{width:60})}" class="ferrule_img"></label>
        <select id="iron-ferrule-select">
        ${ferruleVariants.map((v) => {
          // If variant has no image, use the product featured image
          const imgUrl = v.featured_image.src 
            ? getShopifyImageUrl(v.featured_image.src, {width:60}) 
            : defaultFerruleImg;

          return `
            <option value="${v.id}" data-img="${imgUrl}">
              ${v.option1} ${v.option1 !== 'Standard' ? `(${theme.currencySymbol}${(v.price / 100).toFixed(2)})` : ''} 
            </option>
          `;
        }).join('')}
      </select>
      </div>
    </div>
  `;

  container.insertAdjacentHTML("beforeend", html);

  bindIronAdjustmentEvents();
}

document.addEventListener('change', (e) => {
  if (e.target.id === 'iron-ferrule-select') {
    const select = e.target;
    // Get the selected option element
    const selectedOption = select.options[select.selectedIndex];
    // Get the image URL from the data-img attribute
    const newImgUrl = selectedOption.getAttribute('data-img');
    
    // Find the image relative to the select box
    // It's inside the <label> which is usually a sibling or parent
    const ferruleImg = document.querySelector('.ferrule_img');
    
    if (ferruleImg && newImgUrl) {
      ferruleImg.src = newImgUrl;
    }
  }
});


function bindIronAdjustmentEvents() {
  // Helper to sync the global state with actual DOM values
  const syncAdjustments = () => {
    const ferruleId = Number(document.getElementById('iron-ferrule-select')?.value);
    
    window.__ironAdjustments = {
      length: document.getElementById('shaft-length-select')?.value || 'Standard',
      loft: document.getElementById('iron-loft-select')?.value || 'Standard',
      lie: document.getElementById('iron-lie-select')?.value || 'Standard',
      // Find variant based on current select value
      ferruleVariant: (window.ferrule_product?.variants || []).find(v => v.id === ferruleId) || null,
      spine: document.getElementById('spine-alignment-checkbox')?.checked || false
    };
    
    // Keep secondary global sync if needed for other scripts
    window.__spineAlignment = window.__ironAdjustments.spine;
  };

  // Initial Sync on load
  syncAdjustments();

  // 1. Length, Loft, Lie Listeners
  ['shaft-length-select', 'iron-loft-select', 'iron-lie-select'].forEach(id => {
    document.getElementById(id)?.addEventListener('change', () => {
      syncAdjustments(); // Always pull fresh values from elements
    });
  });

  // 2. Ferrule Listener
  document.getElementById('iron-ferrule-select')?.addEventListener('change', () => {
    syncAdjustments();
    if (typeof updateBuildPrice === 'function') updateBuildPrice();
  });

  // 3. Spine Listener
  document.getElementById('spine-alignment-checkbox')?.addEventListener('change', () => {
    syncAdjustments();
    if (typeof updateBuildPrice === 'function') updateBuildPrice();
  });
}


function initLoftLie() {
  // 1. Determine the club type from product data
  const productType = currentProduct?.type; // e.g., "Iron", "Hybrid", "Driving Iron"
  
  // 2. Look up the specific config for this head type
  const headConfig = CONFIG.clubs_head_type[productType];

  // 3. Safety Check: If no config exists, or both loft and lie are false, hide and exit
  const container = document.getElementById('loftlie-adjustments');
  if (!container) return;

  if (!headConfig || (!headConfig.loft && !headConfig.lie)) {
    container.style.display = 'none';
    return;
  }

  container.style.display = 'block';
  let htmlContent = '';

  // 4. Conditionally build Loft HTML
  if (headConfig.loft) {
    htmlContent += `
    <div class="nbn-advanced">
      <div class="nbn-shaft-length nbn-custom-select">
        <label>Loft</label>
        <select id="iron-loft-select">
          ${window.META_LOFTS.loft_values.map(v => `
            <option ${v === 'Standard' ? 'selected' : ''}>${v}</option>
          `).join('')}
        </select>
      </div>
    </div>`;
  }

  // 5. Conditionally build Lie HTML
  if (headConfig.lie) {
    htmlContent += `
    <div class="nbn-advanced">
      <div class="nbn-shaft-length nbn-custom-select">
        <label>Lie</label>
        <select id="iron-lie-select">
          ${window.META_LIES.lie_values.map(v => `
            <option ${v === 'Standard' ? 'selected' : ''}>${v}</option>
          `).join('')}
        </select>
      </div>
    </div>`;
  }

  container.innerHTML = htmlContent;
}



document.addEventListener('change', e => {
  if (e.target?.id === 'shaft-length-select') {
    // console.log(e.target,e.target.value)
    window.__selectedShaftLength = e.target.value;
  }
});

document.addEventListener("click", e => {
  const btn = e.target.closest(".nbn-info-toggle");
  if (!btn) return;

  const accordion = btn.closest(".nbn-info-accordion");
  accordion.classList.toggle("open");
});

document.addEventListener("click", e => {
  if (e.target.closest(".nbn-info-content")) {
    e.stopPropagation();
  }
});

document
  .querySelector(".nbn-drawer-overlay")
  ?.addEventListener("click", e => {
    if (e.target !== e.currentTarget) return;
    drawerClose("shaft-drawer");
  });



function bindLogoOrientationToggle() {
  const wrap = document.querySelector('#grip-step .gd-toggle');
  if (!wrap) return;

  const buttons = wrap.querySelectorAll('.gd-toggle-btn[data-logoorientation]');
  const switchInput = wrap.querySelector('.gd-switch-input');

  function setOrientation(value) {
    buttons.forEach(btn => {
      btn.setAttribute(
        'aria-pressed',
        btn.dataset.logoorientation === value ? 'true' : 'false'
      );
    });

    if (switchInput) {
      switchInput.checked = value === 'Down';
    }

    updateOrderButtonState();
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      setOrientation(btn.dataset.logoorientation);
    });
  });

  if (switchInput) {
    switchInput.addEventListener('change', e => {
      e.stopPropagation();
      setOrientation(switchInput.checked ? 'Down' : 'Up');
    });
  }
}




/************
 * Add to cart functions start
 *************/

function toShopifyVariantId(gid) {
  return Number(gid.replace('gid://shopify/ProductVariant/', ''));
}

/* ================================================================
   STAFF-ONLY BUILD SPECS
   ----------------------------------------------------------------
   Swing Weight + Tipping  -> rendered here, inside the shaft card,
                              directly under Playing Length.
   Total Weight + Head Weight -> rendered in Liquid, in .order_footer.

   All four are optional. Nothing is added to the cart payload when
   a field is left blank, so non-staff builds are byte-identical to
   what they were before.
   ================================================================ */

window.NBN_SWING_WEIGHTS = window.NBN_SWING_WEIGHTS || [
  'C0','C1','C2','C3','C4','C5','C6','C7','C8','C9',
  'D0','D1','D2','D3','D4','D5','D6','D7','D8','D9',
  'E0','E1','E2','E3','E4','E5'
];

/* Tooltip copy. Override from Liquid (theme settings) by setting
   window.NBN_STAFF_TOOLTIPS before this file loads. Set any key to an
   empty string to hide that field's tooltip entirely. */
window.NBN_STAFF_TOOLTIP_DEFAULTS = window.NBN_STAFF_TOOLTIP_DEFAULTS || {
  swing_weight: 'The balance of the finished club on the Lorythmic scale. Higher letters and numbers feel heavier in the head through the swing.',
  tipping:      'Length trimmed from the tip of the shaft before installation. Tipping stiffens the shaft and typically lowers launch and spin.',
  total_weight: 'The weight of the fully assembled club \u2014 head, shaft, grip and any added weighting combined.',
  head_weight:  'The weight of the club head on its own, before the shaft and grip are fitted.'
};

function getStaffTooltipText(key) {
  const overrides = window.NBN_STAFF_TOOLTIPS || {};
  const override = overrides[key];

  // Explicit null = deliberately hide this tooltip.
  if (override === null) return '';

  // A blank/whitespace override means "nothing was configured" (e.g. an
  // empty theme setting), so fall through to the default rather than
  // silently suppressing the tooltip.
  if (typeof override === 'string' && override.trim() !== '') return override;

  return window.NBN_STAFF_TOOLTIP_DEFAULTS[key] || '';
}

function buildStaffTooltip(key, label) {
  const text = getStaffTooltipText(key);
  if (!text) return '';

  return `
    <button class="nbn-info-btn" type="button" aria-label="${label} info">
      i
      <div class="nbn-tooltip">
        <p>${text}</p>
      </div>
    </button>
  `;
}

// renderSelectedShaftSummary() wipes the shaft card via innerHTML on every
// shaft change, so entered values are cached here and restored on re-render.
window.__staffSpecs = window.__staffSpecs || { swingWeight: '', tipping: '' };

function isStaffCustomer() {
  if (typeof window.staffCustomer !== 'undefined') return !!window.staffCustomer;
  // Fallback: the Liquid staff block only renders for tagged customers.
  return !!document.querySelector('[data-nbn-staff-only]');
}

function buildStaffShaftSpecsHtml() {
  if (!isStaffCustomer()) return '';

  const sw  = window.__staffSpecs.swingWeight || '';
  const tip = window.__staffSpecs.tipping || '';

  const options = window.NBN_SWING_WEIGHTS
    .map(v => `<option value="${v}" ${v === sw ? 'selected' : ''}>${v}</option>`)
    .join('');

  return `
    <div class="nbn-staff-specs" data-nbn-staff-only>
      <div class="nbn-shaft-swingweight nbn-custom-select">
        <label>Swing Weight</label>
        <select id="staff-swing-weight">
          <option value="">&mdash; Not set &mdash;</option>
          ${options}
        </select>
        <button class="nbn-info-btn" type="button" aria-label="Swing Weight info">
          i
          <div class="nbn-tooltip">
            <p>${getStaffTooltipText('swing_weight')}</p>
          </div>
        </button>
      </div>

      <div class="nbn-shaft-tipping nbn-custom-select">
        <label>Tipping</label>
        <div class="nbn-input-wrap">
          <input
            type="number"
            id="staff-tipping"
            inputmode="decimal"
            step="0.25"
            min="0"
            placeholder="0"
            value="${tip}"
          >
          <span class="nbn-unit">in</span>
        </div>
        <button class="nbn-info-btn" type="button" aria-label="Tipping info">
          i
          <div class="nbn-tooltip">
            <p>${getStaffTooltipText('tipping')}</p>
          </div>
        </button>
      </div>
    </div>
  `;
}

function bindStaffShaftSpecs(container) {
  if (!container || !isStaffCustomer()) return;

  container.querySelector('#staff-swing-weight')?.addEventListener('change', e => {
    window.__staffSpecs.swingWeight = e.target.value;
  });

  container.querySelector('#staff-tipping')?.addEventListener('input', e => {
    window.__staffSpecs.tipping = e.target.value;
  });
}

/**
 * Returns the staff spec properties for the cart payload.
 * Empty / unset fields are omitted entirely.
 */
function getStaffBuildSpecs() {
  if (!isStaffCustomer()) return {};

  const read = id => (document.getElementById(id)?.value || '').trim();

  // Live DOM first, cache as fallback (shaft card may not be rendered yet).
  const swingWeight = read('staff-swing-weight') || window.__staffSpecs.swingWeight || '';
  const tipping     = read('staff-tipping')      || window.__staffSpecs.tipping      || '';
  const totalWeight = read('staff-total-weight');
  const headWeight  = read('staff-head-weight');

  return {
    ...(swingWeight && { 'Swing Weight': swingWeight }),
    ...(tipping     && { 'Tipping': `${tipping}"` }),
    ...(totalWeight && { 'Total Weight': `${totalWeight}g` }),
    ...(headWeight  && { 'Head Weight': `${headWeight}g` })
  };
}

function getSelectedAdapter() {
  const el = document.getElementById('shaft-adapter-select');
  return el && el.value ? el.value : null;
}

function getSelectedShaftLength() {
  const el = document.getElementById('shaft-length-select');
  return el && el.value ? el.value : null;
}

function getSelectedSpineVariant() {
  const el = document.getElementById('spine-alignment-checkbox');
  if (!el || !el.checked) return null;
  return Number(el.value);
}

function getSelectedGripTape() {
  const el = document.getElementById('grip-tape-select');
  return el && el.value ? el.value : null;
}

function getSelectedLogoOrientation() {
  const active = document.querySelector(
    '#grip-step .gd-toggle-btn[data-logoorientation][aria-pressed="true"]'
  );
  return active ? active.dataset.logoorientation : null;
}



function isBuildComplete() {
  const b = window.__currentBuild;
  const emailInput = document.getElementById('email');

  if (!b) return false;

  // 1. Irons Check (Only if the product has an irons array)
  if (Array.isArray(b.irons) && b.irons.length === 0) return false;

  // 2. Shaft selection
  if (window.__selectedShaftRequired && !window.__selectedShaft) return false;

  // 3. Grip selection
  if (window.__selectedGripRequired && !window.__selectedGrip) return false;

  // 4. Hosel/Adapter Logic (Only runs if elements exist)
  const fixedHoselCheck = document.getElementById('fixed-hosel-checkbox');
  const brandSel       = document.getElementById('adaptor-brand-select');
  const modelSel       = document.getElementById('adaptor-model-select');
  const headSel        = document.getElementById('adaptor-head-select');
  const settingSel     = document.getElementById('adaptor-setting-select');

  // If these elements exist in the DOM, validate them
  if (fixedHoselCheck || brandSel) {
    const isFixed = fixedHoselCheck?.checked;
    const adapterComplete = brandSel?.value && modelSel?.value && headSel?.value && settingSel?.value;
    
    if (!isFixed && !adapterComplete) return false;
  }

  // 5. Email Validation
  if (emailInput) {
    const email = emailInput.value.trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return false;
  }

  return true;
}

function bindBuildValidation() {

  function shouldTrigger(e) {
    const t = e.target;
    if (!t) return false;

    return (
      t.matches?.('.gd-iron-input') ||
      t.matches?.('#shaft-length-select') ||
      t.matches?.('#fixed-hosel-checkbox') ||
      t.matches?.('#adaptor-brand-select') ||
      t.matches?.('#adaptor-model-select') ||
      t.matches?.('#adaptor-head-select') ||
      t.matches?.('#adaptor-setting-select') ||
      t.matches?.('#email') ||
      t.matches?.('#grip-tape-select') ||
      t.matches?.('#spine-alignment-checkbox') ||
      t.matches?.('input[name="shaft-variant-options-flex"]') ||
      t.matches?.('input[name="shaft-variant-options-model"]') ||
      t.closest?.('.gd-toggle-btn[data-hand]')
    );
  }

  // Global Change Listener
  document.addEventListener('change', e => {
    if (shouldTrigger(e)) {
      updateOrderButtonState();
      
      // If the fixed hosel is checked, immediately clear adapter errors
      if (e.target.id === 'fixed-hosel-checkbox' && e.target.checked) {
        ['#adaptor-brand-select', '#adaptor-model-select', '#adaptor-head-select', '#adaptor-setting-select']
          .forEach(id => document.getElementById(id.replace('#',''))?.parentElement?.classList.remove('has-error'));
      }
    }
  });

  // Email Input Listener
  document.addEventListener('input', e => {
    if (e.target.id === 'email') updateOrderButtonState();
  });

  // Initial State
  updateOrderButtonState();

  // ERROR RESET: When any field changes, remove its specific error styling
  document.addEventListener('change', e => {
    const errorWrapper = e.target.closest('.has-error');
    if (errorWrapper) errorWrapper.classList.remove('has-error');
  });
}

/* ================================================================
   PHONE NUMBER — capture, validate, normalise
   ----------------------------------------------------------------
   Field markup lives in snippets/nbn-phone-field.liquid (id
   #quote-phone). This block reads it, validates the format and
   normalises to E.164 (+447700900123) so the value is consistent
   whether it reaches a draft order, a cart attribute or the Admin API.

   Guarded on window so the three configurator bundles can never
   collide with a duplicate-declaration SyntaxError.
   ================================================================ */

window.NBNPhone = window.NBNPhone || (function () {

  /* ISO-3166 alpha-2 -> country calling code.
     Only used to expand NATIONAL format input (e.g. 07700 900123).
     Numbers typed with a leading + or 00 bypass this entirely, so an
     absent country here degrades to "please include your country
     code" rather than to a wrong number. Extend as markets open. */
  const DIAL = {
    GB:'44', IE:'353', US:'1', CA:'1', AU:'61', NZ:'64', IN:'91',
    FR:'33', DE:'49', ES:'34', IT:'39', PT:'351', NL:'31', BE:'32',
    LU:'352', CH:'41', AT:'43', DK:'45', SE:'46', NO:'47', FI:'358',
    IS:'354', PL:'48', CZ:'420', SK:'421', HU:'36', RO:'40', BG:'359',
    GR:'30', HR:'385', SI:'386', RS:'381', EE:'372', LV:'371', LT:'370',
    CY:'357', MT:'356', JP:'81', CN:'86', HK:'852', SG:'65', MY:'60',
    TH:'66', KR:'82', TW:'886', PH:'63', ID:'62', VN:'84', AE:'971',
    SA:'966', QA:'974', KW:'965', BH:'973', OM:'968', IL:'972',
    TR:'90', ZA:'27', EG:'20', MA:'212', NG:'234', KE:'254',
    MX:'52', BR:'55', AR:'54', CL:'56', CO:'57', PE:'51'
  };

  function dialFor(cc) {
    return DIAL[String(cc || '').toUpperCase()] || null;
  }

  function defaultCountry(el) {
    return (el && el.dataset && el.dataset.defaultCountry)
      || (window.MARKET_CONTEXT && window.MARKET_CONTEXT.country)
      || (window.Shopify && window.Shopify.country)
      || '';
  }

  /**
   * @returns {{ok:boolean, empty:boolean, e164:string, reason:string}}
   */
  function normalise(raw, countryCode) {
    const input = String(raw == null ? '' : raw).trim();

    if (!input) {
      return { ok: false, empty: true, e164: '', reason: 'Enter a phone number.' };
    }

    if (/[A-Za-z]/.test(input)) {
      return { ok: false, empty: false, e164: '', reason: 'Phone number cannot contain letters.' };
    }

    // Strip the punctuation people actually type.
    let s = input.replace(/[\s().\-\/]/g, '');
    let international = false;

    if (s.charAt(0) === '+') {
      international = true;
      s = s.slice(1);
    } else if (s.slice(0, 2) === '00') {
      international = true;      // 00 is the international access prefix
      s = s.slice(2);
    }

    if (!/^\d+$/.test(s)) {
      return { ok: false, empty: false, e164: '', reason: 'Use digits, spaces and + only.' };
    }

    if (!international) {
      const dial = dialFor(countryCode);
      if (!dial) {
        return {
          ok: false, empty: false, e164: '',
          reason: 'Include your country code, e.g. +44 7700 900123.'
        };
      }
      s = s.replace(/^0+/, '');   // drop the national trunk prefix
      if (!s) {
        return { ok: false, empty: false, e164: '', reason: 'Enter a valid phone number.' };
      }
      s = dial + s;
    }

    // E.164 allows a maximum of 15 digits including the country code.
    if (s.length < 8)  return { ok: false, empty: false, e164: '', reason: 'That number looks too short.' };
    if (s.length > 15) return { ok: false, empty: false, e164: '', reason: 'That number looks too long.' };
    if (/^(\d)\1+$/.test(s)) return { ok: false, empty: false, e164: '', reason: 'Enter a valid phone number.' };

    return { ok: true, empty: false, e164: '+' + s, reason: '' };
  }

  return { normalise, defaultCountry, dialFor, DIAL };
})();

function getPhoneFieldEl() {
  return document.getElementById('quote-phone');
}

/** Normalised E.164 value, or '' when absent/blank/invalid. */
function getQuotePhone() {
  const el = getPhoneFieldEl();
  if (!el) return '';
  const res = window.NBNPhone.normalise(el.value, window.NBNPhone.defaultCountry(el));
  return res.ok ? res.e164 : '';
}

function showPhoneError(msg) {
  const el = getPhoneFieldEl();
  if (!el) return;
  if (typeof setFieldError === 'function') setFieldError(el, !!msg);
  const errEl = document.getElementById('quote-phone-error');
  if (errEl) {
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }
}

/** True when the field is absent, or blank-and-optional, or valid. */
function validatePhoneField() {
  const el = getPhoneFieldEl();
  if (!el) return true;

  const required = el.dataset.required === 'true';
  const raw = (el.value || '').trim();

  if (!raw) {
    if (required) { showPhoneError('Phone number is required.'); return false; }
    showPhoneError('');
    return true;
  }

  const res = window.NBNPhone.normalise(raw, window.NBNPhone.defaultCountry(el));
  showPhoneError(res.ok ? '' : res.reason);
  return res.ok;
}

/* Writes the phone onto the CART as an attribute, so it survives into
   the order as a note attribute. That is the hook a Shopify Flow (or a
   webhook on your app) needs in order to write it back to the customer
   record — the storefront cannot update customer.phone directly. */
async function persistPhoneToCart() {
  // No field on this page — leave whatever the cart already carries alone.
  if (!getPhoneFieldEl()) return;

  // Present but empty clears the attribute ('' removes it), otherwise a number
  // staff deleted would keep riding along on the next quote.
  const phone = getQuotePhone();
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Phone Number': phone } })
    });
  } catch (err) {
    // Never block the add-to-cart on this.
    console.error('Phone attribute update failed', err);
  }
}

/* Validate on blur; while typing, only clear an error that is already
   showing, so the customer is not scolded mid-entry. */
document.addEventListener('blur', function (e) {
  if (e.target && e.target.id === 'quote-phone') validatePhoneField();
}, true);

document.addEventListener('input', function (e) {
  if (!e.target || e.target.id !== 'quote-phone') return;
  const errEl = document.getElementById('quote-phone-error');
  const showing = errEl && !errEl.hidden;
  if (showing) validatePhoneField();
});

function setFieldError(el, hasError) {
  if (!el) return;

  const wrapper =
    el.closest('.gd-config') ||
    el.closest('.config-section') ||
    el.parentElement;

  if (hasError) {
    wrapper?.classList.add('has-error');
  } else {
    wrapper?.classList.remove('has-error');
  }
}


function validateBuildAndMarkErrors() {
  let valid = true;

  // Shaft required
  if (!window.__selectedShaft) {
    setFieldError(
      document.getElementById('open-shaft-drawer-btn'),
      true
    );
    valid = false;
  } else {
    setFieldError(
      document.getElementById('open-shaft-drawer-btn'),
      false
    );
  }

  // Grip required
  if (!window.__selectedGrip) {
    setFieldError(
      document.getElementById('open-grip-drawer-btn'),
      true
    );
    valid = false;
  } else {
    setFieldError(
      document.getElementById('open-grip-drawer-btn'),
      false
    );
  }

  // Email (if present)
  const emailEl = document.getElementById('email');
  if (emailEl) {
    const emailValid = emailEl.value && emailEl.value.includes('@');
    setFieldError(emailEl, !emailValid);
    if (!emailValid) valid = false;
  }

  // Phone number (rendered by snippets/nbn-phone-field.liquid)
  if (!validatePhoneField()) valid = false;

  return valid;
}


function updateOrderButtonState() {
  const btn = document.getElementById('orderSubmitButton');
  if (!btn) return;

  btn.disabled = false;
  btn.classList.remove('is-disabled');
}





function bindBuildValidation() {

  function shouldTrigger(e) {
    const t = e.target;

    return (
      t.matches?.('.gd-iron-input') ||
      t.matches?.('#shaft-length-select') ||
      t.matches?.('#shaft-adapter-select') ||
      t.matches?.('#iron-loft-select') ||
      t.matches?.('#iron-lie-select') ||
      t.matches?.('#grip-tape-select') ||
      t.matches?.('#email') ||
      t.matches?.('#spine-alignment-checkbox') ||
      t.matches?.('input[name="shaft-variant-options-flex"]') ||
      t.matches?.('input[name="shaft-variant-options-model"]') ||
      t.closest?.('.gd-toggle-btn[data-hand]') ||
      t.closest?.('.gd-toggle-btn[data-logoorientation]')
    );
  }

  document.addEventListener('change', e => {
    if (shouldTrigger(e)) {
      updateOrderButtonState();
    }
  });

  document.addEventListener('input', e => {
    if (e.target.matches?.('#email')) {
      updateOrderButtonState();
    }
  });

  document.addEventListener('click', e => {
    if (
      e.target.closest?.('.gd-toggle-btn[data-hand]') ||
      e.target.closest?.('.gd-toggle-btn[data-logoorientation]') ||
      e.target.matches?.('#spine-alignment-checkbox')
    ) {
      updateOrderButtonState();
    }
  });

  // Initial evaluation (for defaults)
  updateOrderButtonState();

  document.addEventListener('change', e => {
    const wrapper = e.target.closest?.('.has-error');
    if (wrapper) {
      wrapper.classList.remove('has-error');
    }
  });

}





function getSelectedNativeVariantId() {
  const input = document.querySelector('form[action="/cart/add"] [name="id"]');
  return input ? Number(input.value) : null;
}

/**
 * Returns selected product/variant info based on format:
 * 'both'  -> "Product Title - Variant Title"
 * 'variant' -> "Variant Title"
 * 'product' -> "Product Title"
 */
function getSelectedVariantTitle(format = 'variant') {
  const selectedId = getSelectedNativeVariantId();
  
  if (!selectedId || !window.currentProduct || !window.currentProduct.variants) {
    return null;
  }

  const variant = window.currentProduct.variants.find(v => v.id === selectedId);
  if (!variant) return null;

  const productTitle = window.currentProduct.title;
  const variantTitle = variant.title;

  switch (format) {
    case 'both':
      return `${productTitle} - ${variantTitle}`;
    case 'product':
      return productTitle;
    case 'variant':
    default:
      return variantTitle;
  }
}
function buildAddToCartPayload(topLineSKU) {
  const build = window.__currentBuild;
  const items = [];

  const adapter = getSelectedAdapter();
  const shaftLength = getSelectedShaftLength();
  const gripTape = getSelectedGripTape();
  const logo = getSelectedLogoOrientation();
  const spineVariantId = getSelectedSpineVariant();
  const staffSpecs = getStaffBuildSpecs(); // {} for non-staff

  // ---------- IRONS ----------
  if (Array.isArray(build.irons) && build.irons.length) {
    build.irons.forEach((iron, index) => {
      // Create a unique key for this specific nested group
      // Added index to ensure uniqueness if multiple irons are processed in the same millisecond
      const groupId = `iron-${iron.id}-${Date.now()}-${index}`;
      const parentId = iron.id;
      items.push({
        id: iron.id,
        quantity: 1,
        properties: {
          "Top Line SKU":topLineSKU,
          "_component_id": groupId,
          "_component_role": 'Main',
          ...staffSpecs,
          // "Dexterity": iron.option1,
          // "Iron": iron.option2
        }
      });

      // Note: You will need to update pushChildren to accept groupId and apply it as _parent_id
      pushChildren(items,parentId, groupId, build, adapter, shaftLength, gripTape, logo, spineVariantId, build.ferrule);
    });

    return { items };
  }

  // ---------- NON-IRON ----------
  const groupId = `club-${Date.now()}`;
  const selectedVariantId = getSelectedNativeVariantId();
  const parentId = selectedVariantId;
  const loftVal = document.querySelector(`#iron-loft-select`)?.value || '';
  const leiVal = document.querySelector(`#iron-lie-select`)?.value || '';

  const notes = document.querySelector('textarea[name="order_notes"]')?.value || '';

  console.log('buildPayload selectedShaft',window.__selectedShaft)
  items.push({
    id: selectedVariantId,
    quantity: 1,
    properties: {
      // "Top Line SKU":topLineSKU,
      ...(topLineSKU && {"Top Line SKU":topLineSKU}),
      "_component_id": groupId,      
      "_component_role": 'Main',
      ...(loftVal != '' && {Loft: loftVal}),
      ...(leiVal != '' && {Lie: leiVal}),
      ...(window.__selectedShaft && {"Shaft":`${window.__selectedShaft.productTitle} - ${window.__selectedShaft.variant.variantTitle}`}),
      ...(window.__selectedGrip && {"Grip":`${window.__selectedGrip.productTitle} - ${window.__selectedGrip.variant.variantTitle}`}),
      ...(spineVariantId && {"Spine Alignment":'Yes (+£10.00)'}),
      ...staffSpecs,
      ...(notes && { "Notes":notes, }),
    }
  });

  pushChildren(items, parentId,groupId, build, adapter, shaftLength, gripTape, logo, spineVariantId,build.ferrule);

  return { items };
}


function pushChildren(items, parentId,groupId, build, adapter, shaftLength, gripTape, logo, spineVariantId,ferrule) {

  // console.log('build', build);

  // Helper to get config based on club head type
  const currentClubType= window.currentProduct?.type;
  const config = CONFIG.clubs_head_type[currentClubType];

  // 1. Shaft component
  if (window.__selectedShaft && config) {
    // Check if the selected shaft type is in the 'shafts_to_pull' list for this club
    const shaftType = window.__selectedShaft.product.productType; // Adjust based on your data structure
    const hasShaftDiscount = config.shafts_to_pull.includes(shaftType);
    // console.log('hasShaftDiscount',hasShaftDiscount)
    const shaftDiscountVal = hasShaftDiscount ? config.shaft_discount_amount : null;
    // console.log('shaftDiscountVal',shaftDiscountVal)

    items.push({
      id: toShopifyVariantId(build.shaftVariant.variantId),
      quantity: 1,
      parent_id: parentId,
      properties: {
        "_component_parent_id": groupId,
        "_component_role": 'Component',
        "For":`${getSelectedVariantTitle("both")}`,
        ...(ferrule != null && {"Ferrule":`${ferrule?.title} (+${formatMoney(ferrule.price,"£{{amount}}")})`}),
         // ✅ Only include when NOT staff
        // ...(!window.staffCustomer && shaftLength && { 'Playing Length': shaftLength }),
        // ...(!window.staffCustomer && adapter && { 'Shaft Adaptor': adapter }),
        ...(shaftLength && { 'Playing Length': shaftLength }),
        ...(adapter && { 'Shaft Adaptor': adapter }),
        ...({ "Spine Alignment": spineVariantId ? 'Yes (+£10.00)' : 'No' }),
        // Check for Zero Upcharge first as it usually takes priority
        ...(JSON.parse(window.__selectedShaft?.product?.zeroUpcharge) === true 
            ? { "_zero_upcharge": true } 
            : (shaftDiscountVal !== null ? { [`_shaft_discount`]: shaftDiscountVal } : {}))
      }
    });
  }

  // 2. Grip component
  if (window.__selectedGrip && config) {
    // Check if the selected grip category is in the 'grips_to_pull' list
    const gripType = "Swing Grip"; // You seem to use "Swing Grip" as a standard category
    const hasGripDiscount = config.grips_to_pull.includes(gripType);
    const gripDiscountVal = hasGripDiscount ? config.grip_discount_amount : null;

    items.push({
      id: toShopifyVariantId(build.grip.variant.variantId),
      quantity: 1,
      parent_id: parentId,
      properties: {
        "_component_parent_id": groupId,
        "_component_role": 'Component',
        "For":`${getSelectedVariantTitle("both")}`,
        // "Size": build.grip.product?.options?.size || '',
        // "Colour": build.grip.product?.options?.color || '',
        // ...( !window.staffCustomer && logo && { 'Logo Direction': `Logo ${logo}` } ),
        // ...( !window.staffCustomer && gripTape && { 'Grip Tape': gripTape } ),
        ...( logo && { 'Logo Direction': `Logo ${logo}` } ),
        ...( gripTape && { 'Grip Tape': gripTape } ),
        // Otherwise, include the discount value if it exists.
        ...(JSON.parse(window.__selectedGrip?.product?.zeroUpcharge) === true 
            ? { "_zero_upcharge": true } 
            : (gripDiscountVal !== null ? { [`_grip_discount`]: gripDiscountVal } : {}))
      }
    });
  }

  // 3. Spine Alignment component
  if (spineVariantId) {
    items.push({
      id: spineVariantId,
      quantity: 1,
      parent_id: parentId, // Shopify native nesting link
      properties: {
        "_component_parent_id": groupId,
        "_component_role": 'Component',
        "For":`${getSelectedVariantTitle("both")}`,
        'Spine Alignment': 'Yes (+£10.00)'
      }
    });
  }

  /* ----------------------------------
       FERRULE
    ---------------------------------- */
    if (ferrule) {
      items.push({
        id: ferrule.id,
        parent_id: parentId,
        quantity: 1,
        properties: {
          '_component_parent_id': groupId,
          '_component_role': 'Component',
          "For":`${getSelectedVariantTitle("both")}`,
          ...((ferrule != null && ferrule?.title == 'Standard') && {"_ferrule_discount":'true'})
        }
      });
    }
}

function bindImageDrawerOpener({ imageSelector, drawerSelector }) {
  document.addEventListener('click', e => {
    const img = e.target.closest(imageSelector);
    if (!img) return;

    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    e.preventDefault();
    e.stopPropagation();

    drawer.classList.add('active');
  });
}

function mapBuildPayloadToDraftItems(buildPayload) {
  return buildPayload.items.map(item => ({
    variant_id: Number(item.id),
    quantity: item.quantity,
    attributes: Object.entries(item.properties || {}).map(
      ([key, value]) => ({
        key,
        value: String(value)
      })
    )
  }));
}



/************
 * Add to cart functions ends
 *************/


let isResetting = false;

function resetAdvancedOptions() {
    // 1. STOP if already running to prevent infinite loop
    if (isResetting) return;
    
    isResetting = true; 
    // console.log("Resetting all advanced options...");

    try {
        // 2. Reset Logo Orientation to "Up"
        const logoSwitch = document.querySelector(".nbn-grip-logo .gd-switch-input");
        if (logoSwitch && logoSwitch.checked !== false) {
            logoSwitch.checked = false;
            logoSwitch.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 3. Reset ALL Select Menus (Ferrule, Loft, Lie)
        // 2. Reset Selects with specific defaults
        const selectsToReset = [
            { id: "iron-ferrule-select", defaultIndex: 0 }, // Ferrule usually starts at 0
            { id: "iron-loft-select",    defaultIndex: 4 }, // Standard is at index 4
            { id: "iron-lie-select",     defaultIndex: 4 }  // Standard is at index 4
        ];

        selectsToReset.forEach(config => {
            const el = document.getElementById(config.id);
            if (el && el.selectedIndex !== config.defaultIndex) {
                // console.log(`Resetting ${config.id} to index ${config.defaultIndex}`);
                el.selectedIndex = config.defaultIndex;
                el.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });

        // 4. Uncheck Spine Alignment
        const spineCheckbox = document.getElementById("spine-alignment-checkbox");
        if (spineCheckbox && spineCheckbox.checked !== false) {
            spineCheckbox.checked = false;
            spineCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
    } catch (error) {
        console.error("Error during reset logic:", error);
    } finally {
        // 5. Always unlock the guard at the end
        isResetting = false; 
    }
}

(function () {
  document.addEventListener('DOMContentLoaded', initConfigurator);

  async function initConfigurator() {
    if (!window.currentProduct) return;

    // Step 1: build variant helpers
    const variants = normalizeHeadVariants(currentProduct);
    const { dexIndex, loftIndex, bounceIndex } = resolveOptionIndexes(currentProduct);


    // console.log(dexIndex, loftIndex, bounceIndex)
    // Step 2: init head/loft/hand logic
    initHeadVariantSelection({
      product: currentProduct,
      variants,
      dexIndex,
      loftIndex,
      bounceIndex
    });   
    updateBuildPrice(); // 🔥 ensure UI syncs once both loaded

    const toggle = document.getElementById("advToggle");
    if (!toggle) return;
    // Restore saved state (optional but recommended)
    const saved = localStorage.getItem("nbn_advanced_enabled");
    if (saved === "true") {
      toggle.checked = true;
      document.body.classList.add("nbn-show-advanced");
    }

    toggle.addEventListener("change", () => {
      const enabled = toggle.checked;
      document.body.classList.toggle("nbn-show-advanced", enabled);
      // Persist user preference

      // If Advanced is turned OFF, reset the technical options
        if (!enabled) {
            resetAdvancedOptions();
        }

      localStorage.setItem("nbn_advanced_enabled", enabled);      
    });

    bindBuildValidation();
    updateOrderButtonState();

  document.getElementById('orderSubmitButton')?.addEventListener('click', async (e) => {
    const submitButton = e.currentTarget;

    // 1️⃣ Validate build
    const isValid = validateBuildAndMarkErrors();
    if (!isValid) {
      e.preventDefault();
      e.stopPropagation();
      document.querySelector('.has-error')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
      return;
    }

    // 2️⃣ Access the native Theme Component
    // We find the product-form element to use its internal methods
    const productForm = document.querySelector('product-form');

    // 3️⃣ Native Loading State
    if (submitButton.classList.contains('loading')) return;
    submitButton.classList.add('loading');
    submitButton.setAttribute('aria-disabled', true);

    const topLineSKU = submitButton.getAttribute('data-toplinesku');
    const buildPayload = buildAddToCartPayload(topLineSKU);
    console.log('final buildPayload',buildPayload)
    const isQuotation = submitButton.dataset.mode === 'quotation';

    // 🔹 CASE A: Normal Add to Cart
    if (!isQuotation) {
      try {
        // Get the sections the theme needs to update (mini-cart, cart bubble, etc.)
        const sections = productForm?.getSectionsToRender?.().map((s) => s.section) || [];

        // Store the phone on the cart so it reaches the order.
        await persistPhoneToCart();

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' 
          },
          body: JSON.stringify({
            ...buildPayload,
            sections: sections,
            sections_url: window.location.pathname
          })
        });

        const json = await response.json();

        // Error Handling (Using native theme error logic)
        if (json.status) {
          if (productForm?.handleErrorMessage) {
            productForm.handleErrorMessage(json.description);
          } else {
            alert(json.description);
          }
          
          if (json.status === 422) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          }
          return;
        }

        // SUCCESS: Update the UI using native theme methods
        if (productForm?.renderContents) {
          productForm.renderContents(json);
        }

        // Dispatch event to open drawer/notify other components
        if (typeof dispatchCustomEvent === 'function') {
          dispatchCustomEvent('cart:item-added', {
            product: json.hasOwnProperty('items') ? json.items[0] : json
          });
        }

      } catch (err) {
        console.error('Cart Error:', err);
      } finally {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      return;
    }

    // 🔹 CASE B: Quotation (Draft Order)
    const draftItems = mapBuildPayloadToDraftItems(buildPayload);
    const order_notes = document.querySelector('textarea[name="order_notes"]')?.value || '';

    // Staff-only phone field. getQuotePhone() is '' when absent/blank/invalid,
    // so only attach the key when we have a real number — never send a blank
    // field the app would have to strip out again.
    const quotePhone = getQuotePhone();
    const quoteCustomer = { email: document.getElementById('email')?.value };
    if (quotePhone) quoteCustomer.phone = quotePhone;

    const quotationPayload = {
      shop: Shopify.shop,
      items: draftItems,
      customer: quoteCustomer,
      note: order_notes,
      send_invoice: true,
      // ✅ NEW — market/currency the customer is viewing
      currency:     (window.MARKET_CONTEXT && window.MARKET_CONTEXT.currency) || cart.currency,
      country_code: (window.MARKET_CONTEXT && window.MARKET_CONTEXT.country)  || Shopify.country
    };

    try {
      const res = await fetch(APP_URL + '/api/create-quotation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(quotationPayload)
      });

      const json = await res.json();
      if (!json.success) throw new Error('Quotation failed');
      alert('Quotation request sent successfully!');
    } catch (err) {
      console.error('Quotation error', err);
      alert('Something went wrong.');
    } finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
    }
  });



    initLoftLie();

    // sortLoftOptions();
    
    showSectionLoader('shaft-step');
    // Step 3: fetch shafts + init drawer
    await initShaftFlow();    
    hideSectionLoader('shaft-step');

     // 🔥 Grip MUST be called explicitly
     showSectionLoader('grip-step');
    await initGripFlow();
    hideSectionLoader('grip-step');



    bindImageDrawerOpener({
      imageSelector: '.nbn-shaft-image img',
      drawerSelector: '#shaft-drawer'
    });

    bindImageDrawerOpener({
      imageSelector: '.nbn-grip-image img',
      drawerSelector: '#grip-drawer'
    });

  
    document.addEventListener("click", (e) => {
      // 1. Check if the clicked element is the overlay
      // console.log('e',e)
      if (e.target.matches(".nbn-drawer-overlay")) {
        
        // 2. Since it's the overlay, we close the drawers
        drawerClose("shaft-drawer");
        drawerClose("grip-drawer");
        
        // Optional: add a specific close for the ferrule drawer if you added one
        // drawerClose("ferrule-drawer"); 
      }
    });
    
  }
})();
